// Auto-generated HTML sitemap index (1,300 URLs from the IVI XML sitemap).
// Grouped and alphabetised for humans.

export const SITEMAP_GROUPS = [
 {
  "key": "pages",
  "label": "Main Site Pages",
  "items": [
   {
    "p": "/about/",
    "t": "About"
   },
   {
    "p": "/application/",
    "t": "Application"
   },
   {
    "p": "/about/contact-us/",
    "t": "Contact Us"
   },
   {
    "p": "/ebook/",
    "t": "Ebook"
   },
   {
    "p": "/about/ethical-volunteering/",
    "t": "Ethical Volunteering"
   },
   {
    "p": "/about/faq/",
    "t": "FAQ"
   },
   {
    "p": "/about/how-to-apply/",
    "t": "How to Apply"
   },
   {
    "p": "/ivi-reviews/",
    "t": "IVI Reviews"
   },
   {
    "p": "/about/ivi-videos/",
    "t": "IVI Videos"
   },
   {
    "p": "/overseas-volunteer-programs/",
    "t": "Overseas Volunteer Programs"
   },
   {
    "p": "/projects/",
    "t": "Projects"
   },
   {
    "p": "/about/recent-photos/",
    "t": "Recent Photos"
   },
   {
    "p": "/about/videos/",
    "t": "Videos"
   },
   {
    "p": "/volunteer-abroad-reviews/",
    "t": "Volunteer Abroad Reviews"
   },
   {
    "p": "/volunteer-overseas/",
    "t": "Volunteer Overseas"
   },
   {
    "p": "/about/who-we-are/",
    "t": "Who We Are"
   },
   {
    "p": "/about/why-ivi/",
    "t": "Why IVI"
   }
  ]
 },
 {
  "key": "destinations",
  "label": "Destinations",
  "items": [
   {
    "p": "/projects/argentina/",
    "t": "Argentina"
   },
   {
    "p": "/projects/australia/",
    "t": "Australia"
   },
   {
    "p": "/projects/bali/",
    "t": "Bali"
   },
   {
    "p": "/projects/beach-yoga-hua-hin/",
    "t": "Beach Yoga Hua Hin"
   },
   {
    "p": "/projects/borneo/",
    "t": "Borneo"
   },
   {
    "p": "/projects/cambodia/",
    "t": "Cambodia"
   },
   {
    "p": "/projects/cape-verde/",
    "t": "Cape Verde"
   },
   {
    "p": "/projects/china/",
    "t": "China"
   },
   {
    "p": "/projects/colombia/",
    "t": "Colombia"
   },
   {
    "p": "/projects/costa-rica/",
    "t": "Costa Rica"
   },
   {
    "p": "/projects/cultural-introduction-week-davao/",
    "t": "Cultural Introduction Week Davao"
   },
   {
    "p": "/projects/destinations/",
    "t": "Destinations"
   },
   {
    "p": "/projects/ecuador/",
    "t": "Ecuador"
   },
   {
    "p": "/projects/fiji/",
    "t": "Fiji"
   },
   {
    "p": "/projects/ghana/",
    "t": "Ghana"
   },
   {
    "p": "/projects/greece/",
    "t": "Greece"
   },
   {
    "p": "/projects/guatemala/",
    "t": "Guatemala"
   },
   {
    "p": "/projects/hospitality-tourism-internship-in-manuel-antonio-costa-rica/",
    "t": "Hospitality Tourism Internship in Manuel Antonio Costa Rica"
   },
   {
    "p": "/projects/india/",
    "t": "India"
   },
   {
    "p": "/projects/japan/",
    "t": "Japan"
   },
   {
    "p": "/projects/kenya/",
    "t": "Kenya"
   },
   {
    "p": "/projects/laos/",
    "t": "Laos"
   },
   {
    "p": "/projects/madagascar/",
    "t": "Madagascar"
   },
   {
    "p": "/projects/malawi/",
    "t": "Malawi"
   },
   {
    "p": "/projects/malaysia/",
    "t": "Malaysia"
   },
   {
    "p": "/projects/mexico/",
    "t": "Mexico"
   },
   {
    "p": "/projects/morocco/",
    "t": "Morocco"
   },
   {
    "p": "/projects/nepal/",
    "t": "Nepal"
   },
   {
    "p": "/projects/paid-overseas-teaching-internships/",
    "t": "Paid Overseas Teaching Internships"
   },
   {
    "p": "/projects/papua-new-guinea/",
    "t": "Papua New Guinea"
   },
   {
    "p": "/projects/peru/",
    "t": "Peru"
   },
   {
    "p": "/projects/philippines/",
    "t": "Philippines"
   },
   {
    "p": "/projects/portugal/",
    "t": "Portugal"
   },
   {
    "p": "/projects/samoa/",
    "t": "Samoa"
   },
   {
    "p": "/projects/south-africa/",
    "t": "South Africa"
   },
   {
    "p": "/projects/south-korea/",
    "t": "South Korea"
   },
   {
    "p": "/projects/spain/",
    "t": "Spain"
   },
   {
    "p": "/projects/sports-coaching-with-kids-in-zanzibar/",
    "t": "Sports Coaching with Kids in Zanzibar"
   },
   {
    "p": "/projects/sri-lanka/",
    "t": "Sri Lanka"
   },
   {
    "p": "/projects/ss-test-map/",
    "t": "Ss Test Map"
   },
   {
    "p": "/projects/tanzania/",
    "t": "Tanzania"
   },
   {
    "p": "/projects/thailand/",
    "t": "Thailand"
   },
   {
    "p": "/projects/timor-leste/",
    "t": "Timor Leste"
   },
   {
    "p": "/projects/turkey/",
    "t": "Turkey"
   },
   {
    "p": "/projects/uganda/",
    "t": "Uganda"
   },
   {
    "p": "/projects/vanuatu/",
    "t": "Vanuatu"
   },
   {
    "p": "/projects/vietnam/",
    "t": "Vietnam"
   },
   {
    "p": "/projects/volunteer-ghana/",
    "t": "Volunteer Ghana"
   },
   {
    "p": "/projects/volunteer-peru/",
    "t": "Volunteer Peru"
   },
   {
    "p": "/projects/volunteer-in-argentina/",
    "t": "Volunteer in Argentina"
   },
   {
    "p": "/projects/volunteer-in-australia/",
    "t": "Volunteer in Australia"
   },
   {
    "p": "/projects/volunteer-in-bali/",
    "t": "Volunteer in Bali"
   },
   {
    "p": "/projects/volunteer-in-borneo/",
    "t": "Volunteer in Borneo"
   },
   {
    "p": "/projects/volunteer-in-cambodia/",
    "t": "Volunteer in Cambodia"
   },
   {
    "p": "/projects/volunteer-in-cape-verde/",
    "t": "Volunteer in Cape Verde"
   },
   {
    "p": "/projects/volunteer-in-china/",
    "t": "Volunteer in China"
   },
   {
    "p": "/projects/volunteer-in-colombia/",
    "t": "Volunteer in Colombia"
   },
   {
    "p": "/projects/volunteer-in-costa-rica/",
    "t": "Volunteer in Costa Rica"
   },
   {
    "p": "/projects/volunteer-in-ecuador/",
    "t": "Volunteer in Ecuador"
   },
   {
    "p": "/projects/volunteer-in-fiji/",
    "t": "Volunteer in Fiji"
   },
   {
    "p": "/projects/volunteer-in-greece/",
    "t": "Volunteer in Greece"
   },
   {
    "p": "/projects/volunteer-in-guatemala/",
    "t": "Volunteer in Guatemala"
   },
   {
    "p": "/projects/volunteer-in-india/",
    "t": "Volunteer in India"
   },
   {
    "p": "/projects/volunteer-in-japan/",
    "t": "Volunteer in Japan"
   },
   {
    "p": "/projects/volunteer-in-kenya/",
    "t": "Volunteer in Kenya"
   },
   {
    "p": "/projects/volunteer-in-laos/",
    "t": "Volunteer in Laos"
   },
   {
    "p": "/projects/volunteer-in-malawi/",
    "t": "Volunteer in Malawi"
   },
   {
    "p": "/projects/volunteer-in-malaysia/",
    "t": "Volunteer in Malaysia"
   },
   {
    "p": "/projects/volunteer-in-mexico/",
    "t": "Volunteer in Mexico"
   },
   {
    "p": "/projects/volunteer-in-mongolia/",
    "t": "Volunteer in Mongolia"
   },
   {
    "p": "/projects/volunteer-in-morocco/",
    "t": "Volunteer in Morocco"
   },
   {
    "p": "/projects/volunteer-in-nepal/",
    "t": "Volunteer in Nepal"
   },
   {
    "p": "/projects/volunteer-in-philippines/",
    "t": "Volunteer in Philippines"
   },
   {
    "p": "/projects/volunteer-in-portugal/",
    "t": "Volunteer in Portugal"
   },
   {
    "p": "/projects/volunteer-in-samoa/",
    "t": "Volunteer in Samoa"
   },
   {
    "p": "/projects/volunteer-in-south-africa/",
    "t": "Volunteer in South Africa"
   },
   {
    "p": "/projects/volunteer-in-south-korea/",
    "t": "Volunteer in South Korea"
   },
   {
    "p": "/projects/volunteer-in-sri-lanka/",
    "t": "Volunteer in Sri Lanka"
   },
   {
    "p": "/projects/volunteer-in-thailand/",
    "t": "Volunteer in Thailand"
   },
   {
    "p": "/projects/volunteer-in-timor-leste/",
    "t": "Volunteer in Timor Leste"
   },
   {
    "p": "/projects/volunteer-in-turkey/",
    "t": "Volunteer in Turkey"
   },
   {
    "p": "/projects/volunteer-in-uganda/",
    "t": "Volunteer in Uganda"
   },
   {
    "p": "/projects/volunteer-in-vanuatu/",
    "t": "Volunteer in Vanuatu"
   },
   {
    "p": "/projects/volunteer-in-vietnam/",
    "t": "Volunteer in Vietnam"
   },
   {
    "p": "/projects/volunteer-in-zanzibar/",
    "t": "Volunteer in Zanzibar"
   },
   {
    "p": "/projects/volunteering-for-teens/",
    "t": "Volunteering for Teens"
   },
   {
    "p": "/projects/zanzibar/",
    "t": "Zanzibar"
   }
  ]
 },
 {
  "key": "projects",
  "label": "Volunteer Projects",
  "items": [
   {
    "p": "/projects/cambodia/1-week-cambodia-highlights-tour/",
    "t": "1 Week Cambodia Highlights Tour"
   },
   {
    "p": "/projects/nepal/1-week-pikey-peak-trek-nepal/",
    "t": "1 Week Pikey Peak Trek Nepal"
   },
   {
    "p": "/projects/nepal/1-week-poon-hill-trek-nepal/",
    "t": "1 Week Poon Hill Trek Nepal"
   },
   {
    "p": "/projects/cambodia/1-week-summer-special-in-cambodia-temples-and-adventure/",
    "t": "1 Week Summer Special in Cambodia Temples and Adventure"
   },
   {
    "p": "/projects/kenya/1-week-summer-special-in-kenya-maasai-mara/",
    "t": "1 Week Summer Special in Kenya Maasai Mara"
   },
   {
    "p": "/projects/laos/1-week-summer-special-in-laos-heritage-and-adventure/",
    "t": "1 Week Summer Special in Laos Heritage and Adventure"
   },
   {
    "p": "/projects/nepal/1-week-summer-special-in-nepal-culture-nature-and-adventure/",
    "t": "1 Week Summer Special in Nepal Culture Nature and Adventure"
   },
   {
    "p": "/projects/south-korea/1-week-summer-special-in-south-korea-discover-seoul/",
    "t": "1 Week Summer Special in South Korea Discover Seoul"
   },
   {
    "p": "/projects/tanzania/1-week-summer-special-in-tanzania-arusha/",
    "t": "1 Week Summer Special in Tanzania Arusha"
   },
   {
    "p": "/projects/vietnam/1-week-summer-special-in-vietnam-mangroves-and-culture/",
    "t": "1 Week Summer Special in Vietnam Mangroves and Culture"
   },
   {
    "p": "/projects/philippines/1-week-summer-special-in-the-philippines-palawan/",
    "t": "1 Week Summer Special in the Philippines Palawan"
   },
   {
    "p": "/projects/india/14-day-road-trip-udaipur-agra-goa/",
    "t": "14 Day Road Trip Udaipur Agra Goa"
   },
   {
    "p": "/projects/madagascar/2-week-certified-diving-program-in-nosy-be-madagascar/",
    "t": "2 Week Certified Diving Program in Nosy Be Madagascar"
   },
   {
    "p": "/projects/portugal/2-week-community-volunteering-and-culture-in-lisbon-portugal/",
    "t": "2 Week Community Volunteering and Culture in Lisbon Portugal"
   },
   {
    "p": "/projects/malaysia/2-week-padi-diving-internship-in-borneo-malaysia/",
    "t": "2 Week Padi Diving Internship in Borneo Malaysia"
   },
   {
    "p": "/projects/philippines/2-week-surf-camp-in-el-nido-philippines/",
    "t": "2 Week Surf Camp in El Nido Philippines"
   },
   {
    "p": "/projects/bali/21-day-bali-road-trip/",
    "t": "21 Day Bali Road Trip"
   },
   {
    "p": "/projects/india/21-day-beach-to-himalayas-road-trip/",
    "t": "21 Day Beach to Himalayas Road Trip"
   },
   {
    "p": "/projects/fiji/21-day-fiji-road-trip/",
    "t": "21 Day Fiji Road Trip"
   },
   {
    "p": "/projects/vietnam/21-day-road-trip-vietnam/",
    "t": "21 Day Road Trip Vietnam"
   },
   {
    "p": "/projects/sri-lanka/21-day-road-trip-in-sri-lanka/",
    "t": "21 Day Road Trip in Sri Lanka"
   },
   {
    "p": "/projects/kenya/21-day-volunteer-road-trip-kenya/",
    "t": "21 Day Volunteer Road Trip Kenya"
   },
   {
    "p": "/projects/thailand/21-day-volunteer-road-trip-thailand/",
    "t": "21 Day Volunteer Road Trip Thailand"
   },
   {
    "p": "/projects/zanzibar/21-day-volunteer-road-trip-zanzibar/",
    "t": "21 Day Volunteer Road Trip Zanzibar"
   },
   {
    "p": "/projects/madagascar/3-week-beginner-diving-and-adventure-in-nosy-be-madagascar/",
    "t": "3 Week Beginner Diving and Adventure in Nosy Be Madagascar"
   },
   {
    "p": "/projects/nepal/4-week-annapurna-trek-and-volunteering/",
    "t": "4 Week Annapurna Trek and Volunteering"
   },
   {
    "p": "/projects/sri-lanka/4-week-sri-lanka-wildlife-conservation-experience/",
    "t": "4 Week Sri Lanka Wildlife Conservation Experience"
   },
   {
    "p": "/projects/malaysia/8-week-padi-diving-internship-in-borneo-malaysia/",
    "t": "8 Week Padi Diving Internship in Borneo Malaysia"
   },
   {
    "p": "/projects/bali/adventure-travel-week-bali/",
    "t": "Adventure Travel Week Bali"
   },
   {
    "p": "/projects/laos/adventure-week-luang-prabang-laos/",
    "t": "Adventure Week Luang Prabang Laos"
   },
   {
    "p": "/projects/india/adventure-week-in-goa-india/",
    "t": "Adventure Week in Goa India"
   },
   {
    "p": "/projects/philippines/adventure-week-in-palawan-philippines/",
    "t": "Adventure Week in Palawan Philippines"
   },
   {
    "p": "/projects/mexico/adventure-week-in-puerto-escondido-mexico/",
    "t": "Adventure Week in Puerto Escondido Mexico"
   },
   {
    "p": "/projects/china/adventure-and-culture-week-in-guangxi-province-china/",
    "t": "Adventure and Culture Week in Guangxi Province China"
   },
   {
    "p": "/projects/cambodia/agriculture-and-farming-cambodia/",
    "t": "Agriculture and Farming Cambodia"
   },
   {
    "p": "/projects/japan/agriculture-and-farming-in-otaki-japan/",
    "t": "Agriculture and Farming in Otaki Japan"
   },
   {
    "p": "/projects/peru/alpaca-and-llama-farm-peru/",
    "t": "Alpaca and Llama Farm Peru"
   },
   {
    "p": "/projects/peru/amazon-rainforest-conservation-peru/",
    "t": "Amazon Rainforest Conservation Peru"
   },
   {
    "p": "/projects/sri-lanka/ancient-temples-restoration-project/",
    "t": "Ancient Temples Restoration Project"
   },
   {
    "p": "/projects/tanzania/animal-care-in-arusha-tanzania/",
    "t": "Animal Care in Arusha Tanzania"
   },
   {
    "p": "/projects/costa-rica/animal-care-in-costa-rica/",
    "t": "Animal Care in Costa Rica"
   },
   {
    "p": "/projects/ecuador/animal-rescue-centre-in-macas-ecuador/",
    "t": "Animal Rescue Centre in Macas Ecuador"
   },
   {
    "p": "/projects/ecuador/animal-shelter-care-in-azuay-ecuador/",
    "t": "Animal Shelter Care in Azuay Ecuador"
   },
   {
    "p": "/projects/philippines/animal-shelter-care-in-palawan-philippines/",
    "t": "Animal Shelter Care in Palawan Philippines"
   },
   {
    "p": "/projects/india/animal-shelter-goa-india/",
    "t": "Animal Shelter Goa India"
   },
   {
    "p": "/projects/south-korea/animal-shelter-support-in-south-korea/",
    "t": "Animal Shelter Support in South Korea"
   },
   {
    "p": "/projects/mexico/animal-shelter-in-puerto-escondido-mexico/",
    "t": "Animal Shelter in Puerto Escondido Mexico"
   },
   {
    "p": "/projects/ghana/art-design-teaching-ghana/",
    "t": "Art Design Teaching Ghana"
   },
   {
    "p": "/projects/tanzania/arts-and-music-volunteering-in-arusha-tanzania/",
    "t": "Arts and Music Volunteering in Arusha Tanzania"
   },
   {
    "p": "/projects/australia/australian-wildlife-sanctuary-north-queensland/",
    "t": "Australian Wildlife Sanctuary North Queensland"
   },
   {
    "p": "/projects/turkey/back-to-home-project-empowering-syrian-women-in-izmir-turkey/",
    "t": "Back to Home Project Empowering Syrian Women in Izmir Turkey"
   },
   {
    "p": "/projects/bali/bali-public-health-outreach/",
    "t": "Bali Public Health Outreach"
   },
   {
    "p": "/projects/bali/balinese-yoga-week/",
    "t": "Balinese Yoga Week"
   },
   {
    "p": "/projects/philippines/beach-adventure-week-in-el-nido-palawan/",
    "t": "Beach Adventure Week in El Nido Palawan"
   },
   {
    "p": "/projects/costa-rica/beach-clean-up-nature-reserve/",
    "t": "Beach Clean Up Nature Reserve"
   },
   {
    "p": "/projects/thailand/beach-conservation-hua-hin/",
    "t": "Beach Conservation Hua Hin"
   },
   {
    "p": "/projects/bali/bird-sanctuary-volunteering-in-nusa-penida/",
    "t": "Bird Sanctuary Volunteering in Nusa Penida"
   },
   {
    "p": "/projects/india/bodhisattva-spiritual-retreat-in-bodhgaya-india/",
    "t": "Bodhisattva Spiritual Retreat in Bodhgaya India"
   },
   {
    "p": "/projects/ecuador/boys-youth-drug-and-alcohol-support-in-santo-domingo-ecuador/",
    "t": "Boys Youth Drug and Alcohol Support in Santo Domingo Ecuador"
   },
   {
    "p": "/projects/philippines/boys-youth-rehabilitation/",
    "t": "Boys Youth Rehabilitation"
   },
   {
    "p": "/projects/south-korea/buddhist-immersion-in-seoul-south-korea/",
    "t": "Buddhist Immersion in Seoul South Korea"
   },
   {
    "p": "/projects/nepal/buddhist-monasteries-english-teaching-nepal/",
    "t": "Buddhist Monasteries English Teaching Nepal"
   },
   {
    "p": "/projects/nepal/buddhist-monastery-immersion-in-nepal/",
    "t": "Buddhist Monastery Immersion in Nepal"
   },
   {
    "p": "/projects/india/buddhist-monastery-teaching-in-darjeeling-india/",
    "t": "Buddhist Monastery Teaching in Darjeeling India"
   },
   {
    "p": "/projects/thailand/buddhist-monestary-experience/",
    "t": "Buddhist Monestary Experience"
   },
   {
    "p": "/projects/india/buddhist-monestery-teaching-sikkim/",
    "t": "Buddhist Monestery Teaching Sikkim"
   },
   {
    "p": "/projects/india/ccommunity-support-programs-goa-udaipur-sikkim/",
    "t": "Ccommunity Support Programs Goa Udaipur Sikkim"
   },
   {
    "p": "/projects/south-africa/cheetah-conservation-in-cape-town-south-africa/",
    "t": "Cheetah Conservation in Cape Town South Africa"
   },
   {
    "p": "/projects/ghana/child-care-teaching/",
    "t": "Child Care Teaching"
   },
   {
    "p": "/projects/peru/childcare-peru/",
    "t": "Childcare Peru"
   },
   {
    "p": "/projects/guatemala/childcare-support/",
    "t": "Childcare Support"
   },
   {
    "p": "/projects/tanzania/childcare-support-in-arusha-tanzania/",
    "t": "Childcare Support in Arusha Tanzania"
   },
   {
    "p": "/projects/thailand/childcare-support-in-hua-hin-thailand/",
    "t": "Childcare Support in Hua Hin Thailand"
   },
   {
    "p": "/projects/kenya/childcare-support-in-nakuru-kenya/",
    "t": "Childcare Support in Nakuru Kenya"
   },
   {
    "p": "/projects/morocco/childcare-support-in-rabat-morocco/",
    "t": "Childcare Support in Rabat Morocco"
   },
   {
    "p": "/projects/zanzibar/childcare-support-in-stone-town-zanzibar/",
    "t": "Childcare Support in Stone Town Zanzibar"
   },
   {
    "p": "/projects/cape-verde/childcare-support-in-tarrafal-cape-verde/",
    "t": "Childcare Support in Tarrafal Cape Verde"
   },
   {
    "p": "/projects/spain/childcare-valencia-spain/",
    "t": "Childcare Valencia Spain"
   },
   {
    "p": "/projects/south-africa/childcare-volunteering-in-cape-town-south-africa/",
    "t": "Childcare Volunteering in Cape Town South Africa"
   },
   {
    "p": "/projects/south-korea/childcare-and-after-school-support-in-seoul-south-korea/",
    "t": "Childcare and After School Support in Seoul South Korea"
   },
   {
    "p": "/projects/guatemala/christmas-new-year-holiday-program-guatemala/",
    "t": "Christmas New Year Holiday Program Guatemala"
   },
   {
    "p": "/projects/costa-rica/christmas-and-new-year-special-in-costa-rica/",
    "t": "Christmas and New Year Special in Costa Rica"
   },
   {
    "p": "/projects/peru/christmas-and-new-year-volunteering-in-peru/",
    "t": "Christmas and New Year Volunteering in Peru"
   },
   {
    "p": "/projects/thailand/clay-house-community-construction/",
    "t": "Clay House Community Construction"
   },
   {
    "p": "/projects/bali/clean-up-bali-program/",
    "t": "Clean Up Bali Program"
   },
   {
    "p": "/projects/fiji/clinical-nutrition-and-dietetics-health/",
    "t": "Clinical Nutrition and Dietetics Health"
   },
   {
    "p": "/projects/costa-rica/community-construction/",
    "t": "Community Construction"
   },
   {
    "p": "/projects/ghana/community-construction-ghana/",
    "t": "Community Construction Ghana"
   },
   {
    "p": "/projects/madagascar/community-construction-madagascar/",
    "t": "Community Construction Madagascar"
   },
   {
    "p": "/projects/peru/community-construction-peru/",
    "t": "Community Construction Peru"
   },
   {
    "p": "/projects/vanuatu/community-construction-program/",
    "t": "Community Construction Program"
   },
   {
    "p": "/projects/uganda/community-construction-in-kajjansi-uganda/",
    "t": "Community Construction in Kajjansi Uganda"
   },
   {
    "p": "/projects/cambodia/community-development-cambodia/",
    "t": "Community Development Cambodia"
   },
   {
    "p": "/projects/tanzania/community-development-in-arusha-tanzania/",
    "t": "Community Development in Arusha Tanzania"
   },
   {
    "p": "/projects/uganda/community-farming-in-kanjjansi-uganda/",
    "t": "Community Farming in Kanjjansi Uganda"
   },
   {
    "p": "/projects/guatemala/community-healthcare/",
    "t": "Community Healthcare"
   },
   {
    "p": "/projects/greece/community-support-greece/",
    "t": "Community Support Greece"
   },
   {
    "p": "/projects/philippines/construction/",
    "t": "Construction"
   },
   {
    "p": "/projects/guatemala/construction-renovation/",
    "t": "Construction Renovation"
   },
   {
    "p": "/projects/colombia/construction-renovation-in-cartagena-colombia/",
    "t": "Construction Renovation in Cartagena Colombia"
   },
   {
    "p": "/projects/thailand/construction-renovation-in-hua-hin-thailand/",
    "t": "Construction Renovation in Hua Hin Thailand"
   },
   {
    "p": "/projects/mexico/construction-renovation-in-tepoztlan-mexico/",
    "t": "Construction Renovation in Tepoztlan Mexico"
   },
   {
    "p": "/projects/india/construction-volunteer-programs-india/",
    "t": "Construction Volunteer Programs India"
   },
   {
    "p": "/projects/bali/construction-volunteers-bali/",
    "t": "Construction Volunteers Bali"
   },
   {
    "p": "/projects/madagascar/construction-and-development-in-nosy-komba-madagascar/",
    "t": "Construction and Development in Nosy Komba Madagascar"
   },
   {
    "p": "/projects/timor-leste/construction-and-english-teaching-in-timor-leste/",
    "t": "Construction and English Teaching in Timor Leste"
   },
   {
    "p": "/projects/india/construction-and-renovation-darjeeling-india/",
    "t": "Construction and Renovation Darjeeling India"
   },
   {
    "p": "/projects/thailand/construction-and-renovation-in-chiang-mai-thailand/",
    "t": "Construction and Renovation in Chiang Mai Thailand"
   },
   {
    "p": "/projects/philippines/construction-and-renovation-in-el-nido-palawan/",
    "t": "Construction and Renovation in El Nido Palawan"
   },
   {
    "p": "/projects/india/construction-and-renovation-in-goa-india/",
    "t": "Construction and Renovation in Goa India"
   },
   {
    "p": "/projects/vietnam/construction-and-renovation-in-ha-long-bay-vietnam/",
    "t": "Construction and Renovation in Ha Long Bay Vietnam"
   },
   {
    "p": "/projects/sri-lanka/construction-and-renovation-in-hikkaduwa-sri-lanka/",
    "t": "Construction and Renovation in Hikkaduwa Sri Lanka"
   },
   {
    "p": "/projects/bali/construction-and-renovation-in-lombok-bali/",
    "t": "Construction and Renovation in Lombok Bali"
   },
   {
    "p": "/projects/bali/construction-and-renovation-in-lovina-bali/",
    "t": "Construction and Renovation in Lovina Bali"
   },
   {
    "p": "/projects/malawi/construction-and-renovation-in-mangochi-malawi/",
    "t": "Construction and Renovation in Mangochi Malawi"
   },
   {
    "p": "/projects/tanzania/construction-and-renovation-in-monduli-tanzania/",
    "t": "Construction and Renovation in Monduli Tanzania"
   },
   {
    "p": "/projects/kenya/construction-and-renovation-in-nakuru-kenya/",
    "t": "Construction and Renovation in Nakuru Kenya"
   },
   {
    "p": "/projects/nepal/construction-and-renovation-in-pokhara-nepal/",
    "t": "Construction and Renovation in Pokhara Nepal"
   },
   {
    "p": "/projects/mexico/construction-and-renovation-in-puerto-escondido-mexico/",
    "t": "Construction and Renovation in Puerto Escondido Mexico"
   },
   {
    "p": "/projects/cambodia/construction-and-renovation-in-siem-reap-cambodia/",
    "t": "Construction and Renovation in Siem Reap Cambodia"
   },
   {
    "p": "/projects/zanzibar/construction-and-renovation-in-stone-town-zanzibar/",
    "t": "Construction and Renovation in Stone Town Zanzibar"
   },
   {
    "p": "/projects/cape-verde/construction-and-renovation-in-tarrafal-cape-verde/",
    "t": "Construction and Renovation in Tarrafal Cape Verde"
   },
   {
    "p": "/projects/india/construction-and-renovation-in-udaipur-india/",
    "t": "Construction and Renovation in Udaipur India"
   },
   {
    "p": "/projects/kenya/construction-at-kakuma-refugee-camp-in-kenya/",
    "t": "Construction at Kakuma Refugee Camp in Kenya"
   },
   {
    "p": "/projects/laos/construction-in-luang-prabang-laos/",
    "t": "Construction in Luang Prabang Laos"
   },
   {
    "p": "/projects/japan/conversational-english-exchange/",
    "t": "Conversational English Exchange"
   },
   {
    "p": "/projects/guatemala/cultural-immersion/",
    "t": "Cultural Immersion"
   },
   {
    "p": "/projects/bali/cultural-introduction-week-bali/",
    "t": "Cultural Introduction Week Bali"
   },
   {
    "p": "/projects/cambodia/cultural-introduction-week-cambodia/",
    "t": "Cultural Introduction Week Cambodia"
   },
   {
    "p": "/projects/fiji/cultural-orientation-week-coral-coast-fiji/",
    "t": "Cultural Orientation Week Coral Coast Fiji"
   },
   {
    "p": "/projects/india/cultural-orientation-week-goa-udaipur/",
    "t": "Cultural Orientation Week Goa Udaipur"
   },
   {
    "p": "/projects/bali/cultural-orientation-week-lovina-bali/",
    "t": "Cultural Orientation Week Lovina Bali"
   },
   {
    "p": "/projects/nepal/cultural-orientation-week-nepal/",
    "t": "Cultural Orientation Week Nepal"
   },
   {
    "p": "/projects/philippines/cultural-orientation-week-palawan/",
    "t": "Cultural Orientation Week Palawan"
   },
   {
    "p": "/projects/india/cultural-orientation-week-sikkim-india/",
    "t": "Cultural Orientation Week Sikkim India"
   },
   {
    "p": "/projects/sri-lanka/cultural-orientation-week-sri-lanka/",
    "t": "Cultural Orientation Week Sri Lanka"
   },
   {
    "p": "/projects/zanzibar/cultural-orientation-week-stone-town-zanzibar/",
    "t": "Cultural Orientation Week Stone Town Zanzibar"
   },
   {
    "p": "/projects/tanzania/cultural-orientation-week-tanzania/",
    "t": "Cultural Orientation Week Tanzania"
   },
   {
    "p": "/projects/mexico/cultural-orientation-week-tepoztlan-mexico/",
    "t": "Cultural Orientation Week Tepoztlan Mexico"
   },
   {
    "p": "/projects/vanuatu/cultural-orientation-week-vanuatu/",
    "t": "Cultural Orientation Week Vanuatu"
   },
   {
    "p": "/projects/vietnam/cultural-orientation-week-vietnam/",
    "t": "Cultural Orientation Week Vietnam"
   },
   {
    "p": "/projects/colombia/cultural-orientation-week-in-cartagena-colombia/",
    "t": "Cultural Orientation Week in Cartagena Colombia"
   },
   {
    "p": "/projects/philippines/cultural-orientation-week-in-el-nido-palawan/",
    "t": "Cultural Orientation Week in El Nido Palawan"
   },
   {
    "p": "/projects/laos/cultural-orientation-week-in-luang-prabang-laos/",
    "t": "Cultural Orientation Week in Luang Prabang Laos"
   },
   {
    "p": "/projects/ghana/cultural-orientation-in-ghana/",
    "t": "Cultural Orientation in Ghana"
   },
   {
    "p": "/projects/thailand/culture-week-chiang-mai-thailand/",
    "t": "Culture Week Chiang Mai Thailand"
   },
   {
    "p": "/projects/thailand/culture-week-hua-hin/",
    "t": "Culture Week Hua Hin"
   },
   {
    "p": "/projects/thailand/culture-week-thailand/",
    "t": "Culture Week Thailand"
   },
   {
    "p": "/projects/south-africa/culture-week-in-cape-town-south-africa/",
    "t": "Culture Week in Cape Town South Africa"
   },
   {
    "p": "/projects/india/culture-week-in-darjeeling-india/",
    "t": "Culture Week in Darjeeling India"
   },
   {
    "p": "/projects/china/culture-week-in-guangxi-china/",
    "t": "Culture Week in Guangxi China"
   },
   {
    "p": "/projects/uganda/culture-week-in-kajjansi-uganda/",
    "t": "Culture Week in Kajjansi Uganda"
   },
   {
    "p": "/projects/thailand/culture-week-in-koh-samui-thailand/",
    "t": "Culture Week in Koh Samui Thailand"
   },
   {
    "p": "/projects/bali/culture-week-in-lombok-bali/",
    "t": "Culture Week in Lombok Bali"
   },
   {
    "p": "/projects/malawi/culture-week-in-mangochi-malawi/",
    "t": "Culture Week in Mangochi Malawi"
   },
   {
    "p": "/projects/south-korea/culture-week-in-seoul-south-korea/",
    "t": "Culture Week in Seoul South Korea"
   },
   {
    "p": "/projects/cape-verde/culture-week-in-tarrafal-cape-verde/",
    "t": "Culture Week in Tarrafal Cape Verde"
   },
   {
    "p": "/projects/india/culture-week-in-udaipur-india/",
    "t": "Culture Week in Udaipur India"
   },
   {
    "p": "/projects/nepal/dental-internship-kathmandu-nepal/",
    "t": "Dental Internship Kathmandu Nepal"
   },
   {
    "p": "/projects/guatemala/dental-internship-in-antigua-guatemala/",
    "t": "Dental Internship in Antigua Guatemala"
   },
   {
    "p": "/projects/peru/dental-internship-in-cusco-peru/",
    "t": "Dental Internship in Cusco Peru"
   },
   {
    "p": "/projects/costa-rica/dental-internship-in-san-jose-costa-rica/",
    "t": "Dental Internship in San Jose Costa Rica"
   },
   {
    "p": "/projects/tanzania/early-childhood-education-in-monduli-tanzania/",
    "t": "Early Childhood Education in Monduli Tanzania"
   },
   {
    "p": "/projects/guatemala/eco-farming-agriculture/",
    "t": "Eco Farming Agriculture"
   },
   {
    "p": "/projects/vietnam/eco-farming-in-da-lat-vietnam/",
    "t": "Eco Farming in Da Lat Vietnam"
   },
   {
    "p": "/projects/south-korea/ecological-park-conservation-in-south-korea/",
    "t": "Ecological Park Conservation in South Korea"
   },
   {
    "p": "/projects/guatemala/education-internship-in-antigua-guatemala/",
    "t": "Education Internship in Antigua Guatemala"
   },
   {
    "p": "/projects/peru/education-internship-in-cusco-peru/",
    "t": "Education Internship in Cusco Peru"
   },
   {
    "p": "/projects/costa-rica/education-internship-in-san-jose-costa-rica/",
    "t": "Education Internship in San Jose Costa Rica"
   },
   {
    "p": "/projects/samoa/education-volunteering/",
    "t": "Education Volunteering"
   },
   {
    "p": "/projects/thailand/elephant-adventure-and-conservation-thailand/",
    "t": "Elephant Adventure and Conservation Thailand"
   },
   {
    "p": "/projects/thailand/elephant-care-and-rehabilitation-in-chiang-mai-thailand/",
    "t": "Elephant Care and Rehabilitation in Chiang Mai Thailand"
   },
   {
    "p": "/projects/thailand/elephant-conservation-in-koh-samui-thailand/",
    "t": "Elephant Conservation in Koh Samui Thailand"
   },
   {
    "p": "/projects/fiji/english-sports-teaching-fiji/",
    "t": "English Sports Teaching Fiji"
   },
   {
    "p": "/projects/guatemala/english-teaching/",
    "t": "English Teaching"
   },
   {
    "p": "/projects/costa-rica/english-teaching/",
    "t": "English Teaching"
   },
   {
    "p": "/projects/ghana/english-teaching-ghana/",
    "t": "English Teaching Ghana"
   },
   {
    "p": "/projects/madagascar/english-teaching-madagascar/",
    "t": "English Teaching Madagascar"
   },
   {
    "p": "/projects/vietnam/english-teaching-phan-thiet/",
    "t": "English Teaching Phan Thiet"
   },
   {
    "p": "/projects/nepal/english-teaching-pokhara-nepal/",
    "t": "English Teaching Pokhara Nepal"
   },
   {
    "p": "/projects/india/english-teaching-sikkim-india/",
    "t": "English Teaching Sikkim India"
   },
   {
    "p": "/projects/ecuador/english-teaching-support-in-ecuador/",
    "t": "English Teaching Support in Ecuador"
   },
   {
    "p": "/projects/tanzania/english-teaching-tanzania/",
    "t": "English Teaching Tanzania"
   },
   {
    "p": "/projects/vietnam/english-teaching-vietnam/",
    "t": "English Teaching Vietnam"
   },
   {
    "p": "/projects/malaysia/english-teaching-in-borneo-malaysia/",
    "t": "English Teaching in Borneo Malaysia"
   },
   {
    "p": "/projects/vietnam/english-teaching-in-da-lat-vietnam/",
    "t": "English Teaching in Da Lat Vietnam"
   },
   {
    "p": "/projects/india/english-teaching-in-darjeeling-india/",
    "t": "English Teaching in Darjeeling India"
   },
   {
    "p": "/projects/philippines/english-teaching-in-el-nido-palawan/",
    "t": "English Teaching in El Nido Palawan"
   },
   {
    "p": "/projects/sri-lanka/english-teaching-in-ella-sri-lanka/",
    "t": "English Teaching in Ella Sri Lanka"
   },
   {
    "p": "/projects/sri-lanka/english-teaching-in-hikkaduwa-sri-lanka/",
    "t": "English Teaching in Hikkaduwa Sri Lanka"
   },
   {
    "p": "/projects/thailand/english-teaching-in-hua-hin-thailand/",
    "t": "English Teaching in Hua Hin Thailand"
   },
   {
    "p": "/projects/bali/english-teaching-in-lombok-bali/",
    "t": "English Teaching in Lombok Bali"
   },
   {
    "p": "/projects/bali/english-teaching-in-lovina-bali/",
    "t": "English Teaching in Lovina Bali"
   },
   {
    "p": "/projects/laos/english-teaching-in-luang-prabang-laos/",
    "t": "English Teaching in Luang Prabang Laos"
   },
   {
    "p": "/projects/kenya/english-teaching-in-nakuru-kenya/",
    "t": "English Teaching in Nakuru Kenya"
   },
   {
    "p": "/projects/madagascar/english-teaching-in-nosy-komba-madagascar/",
    "t": "English Teaching in Nosy Komba Madagascar"
   },
   {
    "p": "/projects/mexico/english-teaching-in-puerto-escondido-mexico/",
    "t": "English Teaching in Puerto Escondido Mexico"
   },
   {
    "p": "/projects/cambodia/english-teaching-in-siem-reap-cambodia/",
    "t": "English Teaching in Siem Reap Cambodia"
   },
   {
    "p": "/projects/mexico/english-teaching-in-tepoztlan-mexico/",
    "t": "English Teaching in Tepoztlan Mexico"
   },
   {
    "p": "/projects/spain/english-teaching-in-valencia-spain/",
    "t": "English Teaching in Valencia Spain"
   },
   {
    "p": "/projects/morocco/english-or-french-teaching-in-rabat-morocco/",
    "t": "English or French Teaching in Rabat Morocco"
   },
   {
    "p": "/projects/vietnam/environmental-composting-in-ha-long-bay-vietnam/",
    "t": "Environmental Composting in Ha Long Bay Vietnam"
   },
   {
    "p": "/projects/cambodia/environmental-conservation-cambodia/",
    "t": "Environmental Conservation Cambodia"
   },
   {
    "p": "/projects/philippines/environmental-conservation-philippines/",
    "t": "Environmental Conservation Philippines"
   },
   {
    "p": "/projects/tanzania/environmental-conservation-project/",
    "t": "Environmental Conservation Project"
   },
   {
    "p": "/projects/kenya/environmental-conservation-at-kakuma-refugee-camp-in-kenya/",
    "t": "Environmental Conservation at Kakuma Refugee Camp in Kenya"
   },
   {
    "p": "/projects/vietnam/environmental-conservation-in-da-lat-vietnam/",
    "t": "Environmental Conservation in Da Lat Vietnam"
   },
   {
    "p": "/projects/malawi/environmental-conservation-in-mangochi-malawi/",
    "t": "Environmental Conservation in Mangochi Malawi"
   },
   {
    "p": "/projects/kenya/environmental-conservation-in-nakuru-kenya/",
    "t": "Environmental Conservation in Nakuru Kenya"
   },
   {
    "p": "/projects/mexico/environmental-conservation-in-puerto-escondido-mexico/",
    "t": "Environmental Conservation in Puerto Escondido Mexico"
   },
   {
    "p": "/projects/zanzibar/environmental-conservation-in-stone-town-zanzibar/",
    "t": "Environmental Conservation in Stone Town Zanzibar"
   },
   {
    "p": "/projects/ecuador/environmental-conservation-in-the-galapagos-islands-ecuador/",
    "t": "Environmental Conservation in the Galapagos Islands Ecuador"
   },
   {
    "p": "/projects/spain/environmental-marine-conservation-valencia-spain/",
    "t": "Environmental Marine Conservation Valencia Spain"
   },
   {
    "p": "/projects/argentina/farm-work-support-in-lujan-argentina/",
    "t": "Farm Work Support in Lujan Argentina"
   },
   {
    "p": "/projects/tanzania/farming-and-agriculture-in-arusha-tanzania/",
    "t": "Farming and Agriculture in Arusha Tanzania"
   },
   {
    "p": "/projects/fiji/fiji-disaster-recovery-first-aid/",
    "t": "Fiji Disaster Recovery First Aid"
   },
   {
    "p": "/projects/kenya/food-security-farming/",
    "t": "Food Security Farming"
   },
   {
    "p": "/projects/fiji/food-security-hydroponic-gardens-fiji/",
    "t": "Food Security Hydroponic Gardens Fiji"
   },
   {
    "p": "/projects/portugal/food-support-for-the-homeless-in-lisbon-portugal/",
    "t": "Food Support for the Homeless in Lisbon Portugal"
   },
   {
    "p": "/projects/australia/food-for-the-homeless-sydney-australia/",
    "t": "Food for the Homeless Sydney Australia"
   },
   {
    "p": "/projects/madagascar/forest-conservation-in-nosy-komba-madagascar/",
    "t": "Forest Conservation in Nosy Komba Madagascar"
   },
   {
    "p": "/projects/thailand/forestry-conservation-thailand/",
    "t": "Forestry Conservation Thailand"
   },
   {
    "p": "/projects/thailand/gibbon-rehabilitation-thailand/",
    "t": "Gibbon Rehabilitation Thailand"
   },
   {
    "p": "/projects/nepal/health-education-in-kathmandu-nepal/",
    "t": "Health Education in Kathmandu Nepal"
   },
   {
    "p": "/projects/bali/health-education-in-lombok-bali/",
    "t": "Health Education in Lombok Bali"
   },
   {
    "p": "/projects/zanzibar/healthcare-education-in-stone-town-zanzibar/",
    "t": "Healthcare Education in Stone Town Zanzibar"
   },
   {
    "p": "/projects/tanzania/healthcare-outreach-and-education-in-arusha-tanzania/",
    "t": "Healthcare Outreach and Education in Arusha Tanzania"
   },
   {
    "p": "/projects/fiji/healthcare-project-coral-coast-fiji/",
    "t": "Healthcare Project Coral Coast Fiji"
   },
   {
    "p": "/projects/sri-lanka/hill-country-adventure-trek/",
    "t": "Hill Country Adventure Trek"
   },
   {
    "p": "/projects/thailand/hill-tribe-english-teaching/",
    "t": "Hill Tribe English Teaching"
   },
   {
    "p": "/projects/south-korea/homeless-support-in-south-korea/",
    "t": "Homeless Support in South Korea"
   },
   {
    "p": "/projects/nepal/hospital-internship-nepal/",
    "t": "Hospital Internship Nepal"
   },
   {
    "p": "/projects/sri-lanka/hospital-internship-sri-lanka/",
    "t": "Hospital Internship Sri Lanka"
   },
   {
    "p": "/projects/tanzania/hospital-internship-tanzania/",
    "t": "Hospital Internship Tanzania"
   },
   {
    "p": "/projects/cambodia/hospital-internships-cambodia/",
    "t": "Hospital Internships Cambodia"
   },
   {
    "p": "/projects/zanzibar/hospital-medical-support-in-stone-town-zanzibar/",
    "t": "Hospital Medical Support in Stone Town Zanzibar"
   },
   {
    "p": "/projects/vietnam/hospitality-internship-in-ho-chi-minh-vietnam/",
    "t": "Hospitality Internship in Ho Chi Minh Vietnam"
   },
   {
    "p": "/projects/guatemala/hospitality-tourism-internship-in-antigua-guatemala/",
    "t": "Hospitality Tourism Internship in Antigua Guatemala"
   },
   {
    "p": "/projects/costa-rica/hospitality-tourism-internship-in-manuel-antonio-costa-rica/",
    "t": "Hospitality Tourism Internship in Manuel Antonio Costa Rica"
   },
   {
    "p": "/projects/japan/hospitality-tourism-internship-in-otaki-japan/",
    "t": "Hospitality Tourism Internship in Otaki Japan"
   },
   {
    "p": "/projects/costa-rica/hospitality-tourism-internship-in-san-jose-costa-rica/",
    "t": "Hospitality Tourism Internship in San Jose Costa Rica"
   },
   {
    "p": "/projects/peru/hospitality-and-tourism-internship-in-cusco-peru/",
    "t": "Hospitality and Tourism Internship in Cusco Peru"
   },
   {
    "p": "/projects/guatemala/human-rights-internship-in-antigua-guatemala/",
    "t": "Human Rights Internship in Antigua Guatemala"
   },
   {
    "p": "/projects/peru/human-rights-internship-in-cusco-peru/",
    "t": "Human Rights Internship in Cusco Peru"
   },
   {
    "p": "/projects/costa-rica/human-rights-internship-in-san-jose-costa-rica/",
    "t": "Human Rights Internship in San Jose Costa Rica"
   },
   {
    "p": "/projects/peru/indigenous-communities/",
    "t": "Indigenous Communities"
   },
   {
    "p": "/projects/philippines/island-agriculture-fishing-palawan/",
    "t": "Island Agriculture Fishing Palawan"
   },
   {
    "p": "/projects/ghana/journalism-internship-ghana/",
    "t": "Journalism Internship Ghana"
   },
   {
    "p": "/projects/ecuador/jungle-conservation-in-ecuador/",
    "t": "Jungle Conservation in Ecuador"
   },
   {
    "p": "/projects/thailand/kindergarten-childcare-in-koh-samui-thailand/",
    "t": "Kindergarten Childcare in Koh Samui Thailand"
   },
   {
    "p": "/projects/thailand/kindergarten-education-in-chiang-mai-thailand/",
    "t": "Kindergarten Education in Chiang Mai Thailand"
   },
   {
    "p": "/projects/ecuador/kindergarten-education-in-ecuador/",
    "t": "Kindergarten Education in Ecuador"
   },
   {
    "p": "/projects/portugal/kindergarten-education-in-lisbon-portugal/",
    "t": "Kindergarten Education in Lisbon Portugal"
   },
   {
    "p": "/projects/greece/kindergarten-support-greece/",
    "t": "Kindergarten Support Greece"
   },
   {
    "p": "/projects/vietnam/kindergarten-support-in-ha-long-bay-vietnam/",
    "t": "Kindergarten Support in Ha Long Bay Vietnam"
   },
   {
    "p": "/projects/uganda/kindergarten-support-in-kajjansi-uganda/",
    "t": "Kindergarten Support in Kajjansi Uganda"
   },
   {
    "p": "/projects/costa-rica/kindergarten-teaching/",
    "t": "Kindergarten Teaching"
   },
   {
    "p": "/projects/sri-lanka/kindergarten-teaching/",
    "t": "Kindergarten Teaching"
   },
   {
    "p": "/projects/bali/kindergarten-teaching-bali/",
    "t": "Kindergarten Teaching Bali"
   },
   {
    "p": "/projects/india/kindergarten-teaching-darjeeling-india/",
    "t": "Kindergarten Teaching Darjeeling India"
   },
   {
    "p": "/projects/madagascar/kindergarten-teaching-madagascar/",
    "t": "Kindergarten Teaching Madagascar"
   },
   {
    "p": "/projects/philippines/kindergarten-teaching-palawan/",
    "t": "Kindergarten Teaching Palawan"
   },
   {
    "p": "/projects/nepal/kindergarten-teaching-pokhara-nepal/",
    "t": "Kindergarten Teaching Pokhara Nepal"
   },
   {
    "p": "/projects/vietnam/kindergarten-teaching-vietnam/",
    "t": "Kindergarten Teaching Vietnam"
   },
   {
    "p": "/projects/south-africa/kindergarten-teaching-in-cape-town-south-africa/",
    "t": "Kindergarten Teaching in Cape Town South Africa"
   },
   {
    "p": "/projects/colombia/kindergarten-teaching-in-cartagena-colombia/",
    "t": "Kindergarten Teaching in Cartagena Colombia"
   },
   {
    "p": "/projects/philippines/kindergarten-teaching-in-el-nido-palawan/",
    "t": "Kindergarten Teaching in El Nido Palawan"
   },
   {
    "p": "/projects/bali/kindergarten-teaching-in-lombok-bali/",
    "t": "Kindergarten Teaching in Lombok Bali"
   },
   {
    "p": "/projects/bali/kindergarten-teaching-in-lovina-bali/",
    "t": "Kindergarten Teaching in Lovina Bali"
   },
   {
    "p": "/projects/laos/kindergarten-teaching-in-luang-prabang-laos/",
    "t": "Kindergarten Teaching in Luang Prabang Laos"
   },
   {
    "p": "/projects/malawi/kindergarten-teaching-in-mangochi-malawi/",
    "t": "Kindergarten Teaching in Mangochi Malawi"
   },
   {
    "p": "/projects/mexico/kindergarten-teaching-in-puerto-escondido-mexico/",
    "t": "Kindergarten Teaching in Puerto Escondido Mexico"
   },
   {
    "p": "/projects/fiji/kindergarten-volunteering/",
    "t": "Kindergarten Volunteering"
   },
   {
    "p": "/projects/nepal/kindergarten-volunteering-nepal/",
    "t": "Kindergarten Volunteering Nepal"
   },
   {
    "p": "/projects/thailand/kindergarten-and-childcare-in-koh-samui-thailand/",
    "t": "Kindergarten and Childcare in Koh Samui Thailand"
   },
   {
    "p": "/projects/india/kindergarten-and-outreach-school-in-udaipur-india/",
    "t": "Kindergarten and Outreach School in Udaipur India"
   },
   {
    "p": "/projects/india/kindergarten-and-slum-outreach-in-goa-india/",
    "t": "Kindergarten and Slum Outreach in Goa India"
   },
   {
    "p": "/projects/fiji/koroipita-community-development-construction/",
    "t": "Koroipita Community Development Construction"
   },
   {
    "p": "/projects/fiji/koroipita-community-development-and-education/",
    "t": "Koroipita Community Development and Education"
   },
   {
    "p": "/projects/fiji/koroipita-public-health-and-education/",
    "t": "Koroipita Public Health and Education"
   },
   {
    "p": "/projects/ghana/law-firm-internship-in-accra-ghana/",
    "t": "Law Firm Internship in Accra Ghana"
   },
   {
    "p": "/projects/madagascar/lemur-conservation-madagascar/",
    "t": "Lemur Conservation Madagascar"
   },
   {
    "p": "/projects/morocco/life-skills-teaching-in-rabat-morocco/",
    "t": "Life Skills Teaching in Rabat Morocco"
   },
   {
    "p": "/projects/tanzania/maasai-culture-immersion-in-arusha-tanzania/",
    "t": "Maasai Culture Immersion in Arusha Tanzania"
   },
   {
    "p": "/projects/kenya/maasai-mara-volunteer-teaching/",
    "t": "Maasai Mara Volunteer Teaching"
   },
   {
    "p": "/projects/tanzania/maasai-tribe-community-support/",
    "t": "Maasai Tribe Community Support"
   },
   {
    "p": "/projects/tanzania/maasai-womans-empowerment-program/",
    "t": "Maasai Womans Empowerment Program"
   },
   {
    "p": "/projects/madagascar/mangrove-environmental-conservation/",
    "t": "Mangrove Environmental Conservation"
   },
   {
    "p": "/projects/cambodia/marine-conservation-cambodia/",
    "t": "Marine Conservation Cambodia"
   },
   {
    "p": "/projects/vanuatu/marine-conservation-diving/",
    "t": "Marine Conservation Diving"
   },
   {
    "p": "/projects/madagascar/marine-conservation-in-nosy-komba-madagascar/",
    "t": "Marine Conservation in Nosy Komba Madagascar"
   },
   {
    "p": "/projects/vietnam/martial-arts-training-in-ho-chi-minh-vietnam/",
    "t": "Martial Arts Training in Ho Chi Minh Vietnam"
   },
   {
    "p": "/projects/guatemala/medical-clinic-support/",
    "t": "Medical Clinic Support"
   },
   {
    "p": "/projects/ghana/medical-hospital-internship-ghana/",
    "t": "Medical Hospital Internship Ghana"
   },
   {
    "p": "/projects/india/medical-hospital-internship-goa/",
    "t": "Medical Hospital Internship Goa"
   },
   {
    "p": "/projects/fiji/medical-internship-fiji/",
    "t": "Medical Internship Fiji"
   },
   {
    "p": "/projects/philippines/medical-internship-philippines/",
    "t": "Medical Internship Philippines"
   },
   {
    "p": "/projects/vietnam/medical-internship-vietnam/",
    "t": "Medical Internship Vietnam"
   },
   {
    "p": "/projects/guatemala/medical-internship-in-antigua-guatemala/",
    "t": "Medical Internship in Antigua Guatemala"
   },
   {
    "p": "/projects/bali/medical-internship-in-bali/",
    "t": "Medical Internship in Bali"
   },
   {
    "p": "/projects/peru/medical-internship-in-cusco-peru/",
    "t": "Medical Internship in Cusco Peru"
   },
   {
    "p": "/projects/costa-rica/medical-internship-in-san-jose-costa-rica/",
    "t": "Medical Internship in San Jose Costa Rica"
   },
   {
    "p": "/projects/spain/medical-program-valencia-spain/",
    "t": "Medical Program Valencia Spain"
   },
   {
    "p": "/projects/vietnam/medical-project-in-ha-long-bay-vietnam/",
    "t": "Medical Project in Ha Long Bay Vietnam"
   },
   {
    "p": "/projects/cape-verde/medical-project-in-tarrafal-cape-verde/",
    "t": "Medical Project in Tarrafal Cape Verde"
   },
   {
    "p": "/projects/peru/medical-volunteer-peru/",
    "t": "Medical Volunteer Peru"
   },
   {
    "p": "/projects/kenya/medical-volunteer-work/",
    "t": "Medical Volunteer Work"
   },
   {
    "p": "/projects/costa-rica/medical-volunteering/",
    "t": "Medical Volunteering"
   },
   {
    "p": "/projects/kenya/medical-and-backpack-nurse-in-nakuru-kenya/",
    "t": "Medical and Backpack Nurse in Nakuru Kenya"
   },
   {
    "p": "/projects/vietnam/mekong-delta-home-stay-experience/",
    "t": "Mekong Delta Home Stay Experience"
   },
   {
    "p": "/projects/fiji/mental-health-outreach-in-fiji/",
    "t": "Mental Health Outreach in Fiji"
   },
   {
    "p": "/projects/vanuatu/mental-health-support-in-vanuatu/",
    "t": "Mental Health Support in Vanuatu"
   },
   {
    "p": "/projects/mexico/mexico-culture-week-in-puerto-escondido/",
    "t": "Mexico Culture Week in Puerto Escondido"
   },
   {
    "p": "/projects/guatemala/micro-business-internship-in-antigua-guatemala/",
    "t": "Micro Business Internship in Antigua Guatemala"
   },
   {
    "p": "/projects/peru/micro-business-internship-in-cusco-peru/",
    "t": "Micro Business Internship in Cusco Peru"
   },
   {
    "p": "/projects/costa-rica/micro-business-internship-in-san-jose-costa-rica/",
    "t": "Micro Business Internship in San Jose Costa Rica"
   },
   {
    "p": "/projects/ghana/midwifery-psychology-and-psychiatric-internships-in-accra-ghana/",
    "t": "Midwifery Psychology and Psychiatric Internships in Accra Ghana"
   },
   {
    "p": "/projects/nepal/mount-everest-base-camp-trek/",
    "t": "Mount Everest Base Camp Trek"
   },
   {
    "p": "/projects/kenya/music-dance-and-drama-education-at-kakuma-refugee-camp-kenya/",
    "t": "Music Dance and Drama Education at Kakuma Refugee Camp Kenya"
   },
   {
    "p": "/projects/morocco/ngo-support-in-rabat-morocco/",
    "t": "NGO Support in Rabat Morocco"
   },
   {
    "p": "/projects/borneo/national-park-environmental-conservation-in-kalimantan-borneo/",
    "t": "National Park Environmental Conservation in Kalimantan Borneo"
   },
   {
    "p": "/projects/nepal/nepal-adventure-week/",
    "t": "Nepal Adventure Week"
   },
   {
    "p": "/projects/nepal/nepal-earthquake-rebuilding/",
    "t": "Nepal Earthquake Rebuilding"
   },
   {
    "p": "/projects/sri-lanka/nursing-and-midwifery-internship-in-kandy-sri-lanka/",
    "t": "Nursing and Midwifery Internship in Kandy Sri Lanka"
   },
   {
    "p": "/projects/peru/nutrition-health-volunteer-peru/",
    "t": "Nutrition Health Volunteer Peru"
   },
   {
    "p": "/projects/costa-rica/nutrition-healthcare/",
    "t": "Nutrition Healthcare"
   },
   {
    "p": "/projects/bali/nutrition-healthcare-bali/",
    "t": "Nutrition Healthcare Bali"
   },
   {
    "p": "/projects/vietnam/nutrition-support-poor-ho-chi-minh/",
    "t": "Nutrition Support Poor Ho Chi Minh"
   },
   {
    "p": "/projects/philippines/nutrition-and-public-health/",
    "t": "Nutrition and Public Health"
   },
   {
    "p": "/projects/malaysia/orangutan-care-and-rehabilitation-borneo/",
    "t": "Orangutan Care and Rehabilitation Borneo"
   },
   {
    "p": "/projects/madagascar/orientation-week/",
    "t": "Orientation Week"
   },
   {
    "p": "/projects/samoa/orientation-week-samoa/",
    "t": "Orientation Week Samoa"
   },
   {
    "p": "/projects/thailand/orphanage-childcare-thailand/",
    "t": "Orphanage Childcare Thailand"
   },
   {
    "p": "/projects/fiji/orphanage-volunteer/",
    "t": "Orphanage Volunteer"
   },
   {
    "p": "/projects/nepal/panchase-trek-in-nepal/",
    "t": "Panchase Trek in Nepal"
   },
   {
    "p": "/projects/ghana/physiotherapy-internship-ghana/",
    "t": "Physiotherapy Internship Ghana"
   },
   {
    "p": "/projects/nepal/physiotherapy-internship-nepal/",
    "t": "Physiotherapy Internship Nepal"
   },
   {
    "p": "/projects/philippines/primary-english-teaching/",
    "t": "Primary English Teaching"
   },
   {
    "p": "/projects/philippines/primary-school-english-teaching/",
    "t": "Primary School English Teaching"
   },
   {
    "p": "/projects/nepal/primary-school-teaching/",
    "t": "Primary School Teaching"
   },
   {
    "p": "/projects/vanuatu/primary-school-teaching-vanuatu/",
    "t": "Primary School Teaching Vanuatu"
   },
   {
    "p": "/projects/zanzibar/primary-school-teaching-in-stone-town-zanzibar/",
    "t": "Primary School Teaching in Stone Town Zanzibar"
   },
   {
    "p": "/projects/samoa/public-health-nutrition/",
    "t": "Public Health Nutrition"
   },
   {
    "p": "/projects/vanuatu/public-health-nutrition-volunteer-vanuatu/",
    "t": "Public Health Nutrition Volunteer Vanuatu"
   },
   {
    "p": "/projects/turkey/refugee-humanitarian-support-in-turkey/",
    "t": "Refugee Humanitarian Support in Turkey"
   },
   {
    "p": "/projects/greece/refugee-humanitarian-work-greece/",
    "t": "Refugee Humanitarian Work Greece"
   },
   {
    "p": "/projects/fiji/remote-island-construction-fiji/",
    "t": "Remote Island Construction Fiji"
   },
   {
    "p": "/projects/fiji/remote-island-teaching-in-fiji/",
    "t": "Remote Island Teaching in Fiji"
   },
   {
    "p": "/projects/tanzania/renovation-and-construction-in-arusha-tanzania/",
    "t": "Renovation and Construction in Arusha Tanzania"
   },
   {
    "p": "/projects/thailand/renovation-and-construction-in-koh-samui-thailand/",
    "t": "Renovation and Construction in Koh Samui Thailand"
   },
   {
    "p": "/projects/india/road-trip-india/",
    "t": "Road Trip India"
   },
   {
    "p": "/projects/nepal/road-trip-nepal/",
    "t": "Road Trip Nepal"
   },
   {
    "p": "/projects/india/rural-community-support-bodhgaya/",
    "t": "Rural Community Support Bodhgaya"
   },
   {
    "p": "/projects/india/rural-education-and-immersion-internship-in-bodhgaya-india/",
    "t": "Rural Education and Immersion Internship in Bodhgaya India"
   },
   {
    "p": "/projects/argentina/rural-english-teaching-in-lujan-argentina/",
    "t": "Rural English Teaching in Lujan Argentina"
   },
   {
    "p": "/projects/argentina/rural-environmental-teaching-in-lujan-argentina/",
    "t": "Rural Environmental Teaching in Lujan Argentina"
   },
   {
    "p": "/projects/philippines/rural-healthcare-palawan-philippines/",
    "t": "Rural Healthcare Palawan Philippines"
   },
   {
    "p": "/projects/cambodia/rural-school-teaching-cambodia/",
    "t": "Rural School Teaching Cambodia"
   },
   {
    "p": "/projects/china/rural-teaching-in-guangxi-china/",
    "t": "Rural Teaching in Guangxi China"
   },
   {
    "p": "/projects/china/rural-teaching-in-hainan-china/",
    "t": "Rural Teaching in Hainan China"
   },
   {
    "p": "/projects/argentina/school-renovation-and-maintenance-in-lujan-argentina/",
    "t": "School Renovation and Maintenance in Lujan Argentina"
   },
   {
    "p": "/projects/greece/school-teaching-support-in-chios-greece/",
    "t": "School Teaching Support in Chios Greece"
   },
   {
    "p": "/projects/south-korea/soup-kitchen-support-in-south-korea/",
    "t": "Soup Kitchen Support in South Korea"
   },
   {
    "p": "/projects/colombia/spanish-lessons-in-cartagena-colombia/",
    "t": "Spanish Lessons in Cartagena Colombia"
   },
   {
    "p": "/projects/guatemala/special-education-internship-in-antigua-guatemala/",
    "t": "Special Education Internship in Antigua Guatemala"
   },
   {
    "p": "/projects/peru/special-education-internship-in-cusco-peru/",
    "t": "Special Education Internship in Cusco Peru"
   },
   {
    "p": "/projects/costa-rica/special-education-internship-in-san-jose-costa-rica/",
    "t": "Special Education Internship in San Jose Costa Rica"
   },
   {
    "p": "/projects/fiji/special-needs/",
    "t": "Special Needs"
   },
   {
    "p": "/projects/vietnam/special-needs-care-vietnam/",
    "t": "Special Needs Care Vietnam"
   },
   {
    "p": "/projects/malaysia/special-needs-care-and-education-in-borneo-malaysia/",
    "t": "Special Needs Care and Education in Borneo Malaysia"
   },
   {
    "p": "/projects/philippines/special-needs-school-leyte-philippines/",
    "t": "Special Needs School Leyte Philippines"
   },
   {
    "p": "/projects/ecuador/special-needs-support-for-kids-and-teenagers-in-ecuador/",
    "t": "Special Needs Support for Kids and Teenagers in Ecuador"
   },
   {
    "p": "/projects/kenya/special-needs-teaching/",
    "t": "Special Needs Teaching"
   },
   {
    "p": "/projects/sri-lanka/special-needs-teaching-community-support/",
    "t": "Special Needs Teaching Community Support"
   },
   {
    "p": "/projects/nepal/special-needs-teaching-in-kathmandu-nepal/",
    "t": "Special Needs Teaching in Kathmandu Nepal"
   },
   {
    "p": "/projects/spain/special-needs-valencia-spain/",
    "t": "Special Needs Valencia Spain"
   },
   {
    "p": "/projects/ghana/sports-coaching-ghana/",
    "t": "Sports Coaching Ghana"
   },
   {
    "p": "/projects/thailand/sports-coaching-thailand/",
    "t": "Sports Coaching Thailand"
   },
   {
    "p": "/projects/kenya/sports-coaching-at-kakuma-refugee-camp-kenya/",
    "t": "Sports Coaching at Kakuma Refugee Camp Kenya"
   },
   {
    "p": "/projects/thailand/sports-coaching-in-hua-hin-thailand/",
    "t": "Sports Coaching in Hua Hin Thailand"
   },
   {
    "p": "/projects/uganda/sports-coaching-in-kajjansi-uganda/",
    "t": "Sports Coaching in Kajjansi Uganda"
   },
   {
    "p": "/projects/bali/sports-coaching-in-lombok-bali/",
    "t": "Sports Coaching in Lombok Bali"
   },
   {
    "p": "/projects/bali/sports-coaching-in-lovina-bali/",
    "t": "Sports Coaching in Lovina Bali"
   },
   {
    "p": "/projects/laos/sports-coaching-in-luang-prabang-laos/",
    "t": "Sports Coaching in Luang Prabang Laos"
   },
   {
    "p": "/projects/tanzania/sports-coaching-in-monduli-tanzania/",
    "t": "Sports Coaching in Monduli Tanzania"
   },
   {
    "p": "/projects/morocco/sports-coaching-in-rabat-morocco/",
    "t": "Sports Coaching in Rabat Morocco"
   },
   {
    "p": "/projects/cambodia/sports-coaching-in-samraong-cambodia/",
    "t": "Sports Coaching in Samraong Cambodia"
   },
   {
    "p": "/projects/cape-verde/sports-coaching-in-tarrafal-cape-verde/",
    "t": "Sports Coaching in Tarrafal Cape Verde"
   },
   {
    "p": "/projects/india/sports-coaching-in-udaipur-india/",
    "t": "Sports Coaching in Udaipur India"
   },
   {
    "p": "/projects/fiji/sports-teaching-coral-coast-fiji/",
    "t": "Sports Teaching Coral Coast Fiji"
   },
   {
    "p": "/projects/thailand/sports-and-management-in-singburi-thailand/",
    "t": "Sports and Management in Singburi Thailand"
   },
   {
    "p": "/projects/colombia/stem-education-in-cartagena-colombia/",
    "t": "Stem Education in Cartagena Colombia"
   },
   {
    "p": "/projects/guatemala/stray-dog-cat-rehabilitation/",
    "t": "Stray Dog Cat Rehabilitation"
   },
   {
    "p": "/projects/nepal/stray-dog-rehabilitation/",
    "t": "Stray Dog Rehabilitation"
   },
   {
    "p": "/projects/bali/stray-dog-rehabilitation-bali/",
    "t": "Stray Dog Rehabilitation Bali"
   },
   {
    "p": "/projects/india/stray-dog-rehabilitation-in-darjeeling-india/",
    "t": "Stray Dog Rehabilitation in Darjeeling India"
   },
   {
    "p": "/projects/peru/stray-dog-shelter-volunteer/",
    "t": "Stray Dog Shelter Volunteer"
   },
   {
    "p": "/projects/philippines/street-children-support-program/",
    "t": "Street Children Support Program"
   },
   {
    "p": "/projects/costa-rica/sustainable-farming-agriculture/",
    "t": "Sustainable Farming Agriculture"
   },
   {
    "p": "/projects/argentina/sustainable-greenhouse-horticulture-in-lujan-argentina/",
    "t": "Sustainable Greenhouse Horticulture in Lujan Argentina"
   },
   {
    "p": "/projects/greece/syrian-refugee-crisis-volunteering/",
    "t": "Syrian Refugee Crisis Volunteering"
   },
   {
    "p": "/projects/thailand/teach-english-primary-schools-thailand/",
    "t": "Teach English Primary Schools Thailand"
   },
   {
    "p": "/projects/kenya/teaching/",
    "t": "Teaching"
   },
   {
    "p": "/projects/peru/teaching-english-peru/",
    "t": "Teaching English Peru"
   },
   {
    "p": "/projects/thailand/teaching-english-in-chiang-mai-thailand/",
    "t": "Teaching English in Chiang Mai Thailand"
   },
   {
    "p": "/projects/sri-lanka/teaching-english-to-buddhist-monks/",
    "t": "Teaching English to Buddhist Monks"
   },
   {
    "p": "/projects/philippines/teaching-internship-phillipines/",
    "t": "Teaching Internship Phillipines"
   },
   {
    "p": "/projects/vietnam/teaching-internship-in-ho-chi-minh-vietnam/",
    "t": "Teaching Internship in Ho Chi Minh Vietnam"
   },
   {
    "p": "/projects/south-africa/teaching-support-in-cape-town-south-africa/",
    "t": "Teaching Support in Cape Town South Africa"
   },
   {
    "p": "/projects/uganda/teaching-support-in-kajjansi-uganda/",
    "t": "Teaching Support in Kajjansi Uganda"
   },
   {
    "p": "/projects/malawi/teaching-support-in-mangochi-malawi/",
    "t": "Teaching Support in Mangochi Malawi"
   },
   {
    "p": "/projects/colombia/teaching-and-education-in-cartagena-colombia/",
    "t": "Teaching and Education in Cartagena Colombia"
   },
   {
    "p": "/projects/cape-verde/teaching-and-education-in-tarrafal-cape-verde/",
    "t": "Teaching and Education in Tarrafal Cape Verde"
   },
   {
    "p": "/projects/kenya/teaching-at-kakuma-refugee-camp-kenya/",
    "t": "Teaching at Kakuma Refugee Camp Kenya"
   },
   {
    "p": "/projects/tanzania/teaching-in-arusha-tanzania/",
    "t": "Teaching in Arusha Tanzania"
   },
   {
    "p": "/projects/thailand/teaching-in-koh-samui-thailand/",
    "t": "Teaching in Koh Samui Thailand"
   },
   {
    "p": "/projects/thailand/thai-buddhism-experience/",
    "t": "Thai Buddhism Experience"
   },
   {
    "p": "/projects/cape-verde/trekking-week-in-tarrafal-cape-verde/",
    "t": "Trekking Week in Tarrafal Cape Verde"
   },
   {
    "p": "/projects/costa-rica/turtle-conservation/",
    "t": "Turtle Conservation"
   },
   {
    "p": "/projects/guatemala/turtle-conservation/",
    "t": "Turtle Conservation"
   },
   {
    "p": "/projects/bali/turtle-conservation-bali/",
    "t": "Turtle Conservation Bali"
   },
   {
    "p": "/projects/sri-lanka/turtle-conservation-sri-lanka/",
    "t": "Turtle Conservation Sri Lanka"
   },
   {
    "p": "/projects/china/turtle-conservation-in-huidong-china/",
    "t": "Turtle Conservation in Huidong China"
   },
   {
    "p": "/projects/bali/turtle-conservation-in-lombok-bali/",
    "t": "Turtle Conservation in Lombok Bali"
   },
   {
    "p": "/projects/madagascar/turtle-conservation-in-nosy-komba-madagascar/",
    "t": "Turtle Conservation in Nosy Komba Madagascar"
   },
   {
    "p": "/projects/zanzibar/turtle-conservation-in-nungwi-zanzibar/",
    "t": "Turtle Conservation in Nungwi Zanzibar"
   },
   {
    "p": "/projects/cape-verde/turtle-conservation-in-tarrafal-cape-verde/",
    "t": "Turtle Conservation in Tarrafal Cape Verde"
   },
   {
    "p": "/projects/vietnam/upcycling-recycle-program-in-ha-long-bay-vietnam/",
    "t": "Upcycling Recycle Program in Ha Long Bay Vietnam"
   },
   {
    "p": "/projects/guatemala/veterinary-internship-in-antigua-guatemala/",
    "t": "Veterinary Internship in Antigua Guatemala"
   },
   {
    "p": "/projects/peru/veterinary-internship-in-cusco-peru/",
    "t": "Veterinary Internship in Cusco Peru"
   },
   {
    "p": "/projects/costa-rica/veterinary-internship-in-san-jose-costa-rica/",
    "t": "Veterinary Internship in San Jose Costa Rica"
   },
   {
    "p": "/projects/nepal/veterinary-medicine-support-in-kathmandu-nepal/",
    "t": "Veterinary Medicine Support in Kathmandu Nepal"
   },
   {
    "p": "/projects/kenya/voluntary-work-kenya-maasai-mara/",
    "t": "Voluntary Work Kenya Maasai Mara"
   },
   {
    "p": "/projects/fiji/volunteer-construction-fiji/",
    "t": "Volunteer Construction Fiji"
   },
   {
    "p": "/projects/bali/volunteer-teaching-bali/",
    "t": "Volunteer Teaching Bali"
   },
   {
    "p": "/projects/spain/volunteer-in-spain/",
    "t": "Volunteer in Spain"
   },
   {
    "p": "/projects/fiji/volunteer-with-animals/",
    "t": "Volunteer with Animals"
   },
   {
    "p": "/projects/cambodia/volunteering-road-trip-cambodia/",
    "t": "Volunteering Road Trip Cambodia"
   },
   {
    "p": "/projects/ecuador/wild-animal-clinic-and-rehabilitation-in-santo-domingo-ecuador/",
    "t": "Wild Animal Clinic and Rehabilitation in Santo Domingo Ecuador"
   },
   {
    "p": "/projects/kenya/wildlife-conservation-in-nakuru-kenya/",
    "t": "Wildlife Conservation in Nakuru Kenya"
   },
   {
    "p": "/projects/bali/wildlife-rescue-in-tabanan-bali/",
    "t": "Wildlife Rescue in Tabanan Bali"
   },
   {
    "p": "/projects/bali/wildlife-sanctuary-in-besikalung-bali/",
    "t": "Wildlife Sanctuary in Besikalung Bali"
   },
   {
    "p": "/projects/australia/wildlife-zoo-volunteering-newcastle-australia/",
    "t": "Wildlife Zoo Volunteering Newcastle Australia"
   },
   {
    "p": "/projects/bali/wildlife-and-community-centre-in-pejeng-bali/",
    "t": "Wildlife and Community Centre in Pejeng Bali"
   },
   {
    "p": "/projects/fiji/woman-children-commune-fiji/",
    "t": "Woman Children Commune Fiji"
   },
   {
    "p": "/projects/nepal/womans-empowerment-education/",
    "t": "Womans Empowerment Education"
   },
   {
    "p": "/projects/kenya/women-empowerment-at-kakuma-refugee-camp-kenya/",
    "t": "Women Empowerment at Kakuma Refugee Camp Kenya"
   },
   {
    "p": "/projects/morocco/womens-education-in-rabat-morocco/",
    "t": "Womens Education in Rabat Morocco"
   },
   {
    "p": "/projects/tanzania/womens-empowerment-in-arusha-tanzania/",
    "t": "Womens Empowerment in Arusha Tanzania"
   },
   {
    "p": "/projects/kenya/womens-empowerment-in-nakuru-kenya/",
    "t": "Womens Empowerment in Nakuru Kenya"
   },
   {
    "p": "/projects/bali/womens-empowerment-in-ubud-bali/",
    "t": "Womens Empowerment in Ubud Bali"
   },
   {
    "p": "/projects/philippines/womens-welfare/",
    "t": "Womens Welfare"
   },
   {
    "p": "/projects/bali/yoga-and-meditation-in-lovina-bali/",
    "t": "Yoga and Meditation in Lovina Bali"
   }
  ]
 },
 {
  "key": "topics",
  "label": "Browse by Topic",
  "items": [
   {
    "p": "/travel-category/adventure-week/",
    "t": "Adventure Week"
   },
   {
    "p": "/travel-category/best-volunteer-abroad-projects/",
    "t": "Best Volunteer Abroad Projects"
   },
   {
    "p": "/travel-category/community-support/",
    "t": "Community Support"
   },
   {
    "p": "/travel-category/construction-volunteer-opportunities/",
    "t": "Construction Volunteer Opportunities"
   },
   {
    "p": "/travel-category/cultural-orientations/",
    "t": "Cultural Orientations"
   },
   {
    "p": "/travel-category/disaster-relief/",
    "t": "Disaster Relief"
   },
   {
    "p": "/travel-category/environmental-conservation/",
    "t": "Environmental Conservation"
   },
   {
    "p": "/travel-category/family-volunteering/",
    "t": "Family Volunteering"
   },
   {
    "p": "/travel-category/farming/",
    "t": "Farming"
   },
   {
    "p": "/travel-category/gap-year-volunteer-programs/",
    "t": "Gap Year Volunteer Programs"
   },
   {
    "p": "/travel-category/group-volunteering/",
    "t": "Group Volunteering"
   },
   {
    "p": "/travel-category/home-stays/",
    "t": "Home Stays"
   },
   {
    "p": "/travel-category/humanitarian-aid/",
    "t": "Humanitarian Aid"
   },
   {
    "p": "/travel-category/hydroponic-gardens/",
    "t": "Hydroponic Gardens"
   },
   {
    "p": "/travel-category/internships/",
    "t": "Internships"
   },
   {
    "p": "/travel-category/journalism-internships/",
    "t": "Journalism Internships"
   },
   {
    "p": "/travel-category/marine-conservation/",
    "t": "Marine Conservation"
   },
   {
    "p": "/travel-category/medical-volunteer/",
    "t": "Medical Volunteer"
   },
   {
    "p": "/travel-category/mental-health/",
    "t": "Mental Health"
   },
   {
    "p": "/travel-category/nutrition-volunteer-opportunities/",
    "t": "Nutrition Volunteer Opportunities"
   },
   {
    "p": "/travel-category/paid-internships/",
    "t": "Paid Internships"
   },
   {
    "p": "/travel-category/refugee-support-programs/",
    "t": "Refugee Support Programs"
   },
   {
    "p": "/travel-category/road-trips/",
    "t": "Road Trips"
   },
   {
    "p": "/travel-category/special-needs/",
    "t": "Special Needs"
   },
   {
    "p": "/travel-category/sport-coaching/",
    "t": "Sport Coaching"
   },
   {
    "p": "/travel-category/teach-overseas/",
    "t": "Teach Overseas"
   },
   {
    "p": "/travel-category/volunteer-refugee-camp/",
    "t": "Volunteer Refugee Camp"
   },
   {
    "p": "/travel-category/volunteer-tours/",
    "t": "Volunteer Tours"
   },
   {
    "p": "/travel-category/volunteering-with-animals/",
    "t": "Volunteering with Animals"
   },
   {
    "p": "/travel-category/volunteering-with-children/",
    "t": "Volunteering with Children"
   },
   {
    "p": "/travel-category/womans-empowerment/",
    "t": "Womans Empowerment"
   }
  ]
 },
 {
  "key": "reviews",
  "label": "Volunteer Reviews & Stories",
  "items": [
   {
    "p": "/3-week-road-trip-in-vietnam-review/",
    "t": "3 Week Road Trip in Vietnam Review"
   },
   {
    "p": "/6-weeks-in-kenya-niklass-experience/",
    "t": "6 Weeks in Kenya Niklass Experience"
   },
   {
    "p": "/a-nutrition-project-review-in-vanuatu/",
    "t": "A Nutrition Project Review in Vanuatu"
   },
   {
    "p": "/add-a-diploma-to-your-volunteer-experience-with-ivi/",
    "t": "Add a Diploma to your Volunteer Experience with IVI"
   },
   {
    "p": "/amazon-jungle-conservation-review/",
    "t": "Amazon Jungle Conservation Review"
   },
   {
    "p": "/animal-shelter-fiji-testimonial/",
    "t": "Animal Shelter Fiji Testimonial"
   },
   {
    "p": "/animal-shelter-review-in-fiji/",
    "t": "Animal Shelter Review in Fiji"
   },
   {
    "p": "/animal-shelter-in-fiji-review-of-project/",
    "t": "Animal Shelter in Fiji Review of Project"
   },
   {
    "p": "/animal-volunteering-in-fiji-review/",
    "t": "Animal Volunteering in Fiji Review"
   },
   {
    "p": "/australian-wildlife-project-review-by-charmaine/",
    "t": "Australian Wildlife Project Review by Charmaine"
   },
   {
    "p": "/australian-zoo-volunteering-review-by-sonja/",
    "t": "Australian Zoo Volunteering Review by Sonja"
   },
   {
    "p": "/bali-health-education-testimonial/",
    "t": "Bali Health Education Testimonial"
   },
   {
    "p": "/bali-healthcare-education-review/",
    "t": "Bali Healthcare Education Review"
   },
   {
    "p": "/bali-healthcare-education-review-2/",
    "t": "Bali Healthcare Education Review 2"
   },
   {
    "p": "/bali-kindy-review-in-ubud/",
    "t": "Bali Kindy Review in Ubud"
   },
   {
    "p": "/bali-kindy-teaching-review/",
    "t": "Bali Kindy Teaching Review"
   },
   {
    "p": "/bali-nutrition-review-by-inga/",
    "t": "Bali Nutrition Review by Inga"
   },
   {
    "p": "/bali-teaching-review-joanna/",
    "t": "Bali Teaching Review Joanna"
   },
   {
    "p": "/bali-teaching-review-by-eba/",
    "t": "Bali Teaching Review by Eba"
   },
   {
    "p": "/bali-turtle-conservation-review/",
    "t": "Bali Turtle Conservation Review"
   },
   {
    "p": "/bali-turtle-project-review-sam/",
    "t": "Bali Turtle Project Review Sam"
   },
   {
    "p": "/bali-turtles-program-review/",
    "t": "Bali Turtles Program Review"
   },
   {
    "p": "/bali-turtles-review/",
    "t": "Bali Turtles Review"
   },
   {
    "p": "/bali-ubud-healthcare-education-review/",
    "t": "Bali Ubud Healthcare Education Review"
   },
   {
    "p": "/buddhist-monastery-nepal-teaching-experience/",
    "t": "Buddhist Monastery Nepal Teaching Experience"
   },
   {
    "p": "/cambodia-construction-review-jack/",
    "t": "Cambodia Construction Review Jack"
   },
   {
    "p": "/cambodia-renovation-review/",
    "t": "Cambodia Renovation Review"
   },
   {
    "p": "/cambodia-rural-english-teaching-review/",
    "t": "Cambodia Rural English Teaching Review"
   },
   {
    "p": "/cambodia-teaching-review/",
    "t": "Cambodia Teaching Review"
   },
   {
    "p": "/canine-rehabilitation-nepal-review/",
    "t": "Canine Rehabilitation Nepal Review"
   },
   {
    "p": "/cheetah-conservation-review-south-africa/",
    "t": "Cheetah Conservation Review South Africa"
   },
   {
    "p": "/chiang-mai-thailand-kindergarten-program-review/",
    "t": "Chiang Mai Thailand Kindergarten Program Review"
   },
   {
    "p": "/childcare-program-in-south-korea-review/",
    "t": "Childcare Program in South Korea Review"
   },
   {
    "p": "/childcare-in-fiji-review/",
    "t": "Childcare in Fiji Review"
   },
   {
    "p": "/childcare-in-hua-hin-thailand-review/",
    "t": "Childcare in Hua Hin Thailand Review"
   },
   {
    "p": "/childrens-home-fiji-review/",
    "t": "Childrens Home Fiji Review"
   },
   {
    "p": "/childrens-home-fiji-review-2/",
    "t": "Childrens Home Fiji Review 2"
   },
   {
    "p": "/childrens-home-fiji-review-3/",
    "t": "Childrens Home Fiji Review 3"
   },
   {
    "p": "/childrens-home-placement-review-fiji/",
    "t": "Childrens Home Placement Review Fiji"
   },
   {
    "p": "/childrens-home-support-review/",
    "t": "Childrens Home Support Review"
   },
   {
    "p": "/childrens-home-volunteering-feedback/",
    "t": "Childrens Home Volunteering Feedback"
   },
   {
    "p": "/childrens-orphanage-volunteering-fiji-review/",
    "t": "Childrens Orphanage Volunteering Fiji Review"
   },
   {
    "p": "/commune-placement-fiji-review/",
    "t": "Commune Placement Fiji Review"
   },
   {
    "p": "/construction-childcare-in-hua-hin-thailand-review/",
    "t": "Construction Childcare in Hua Hin Thailand Review"
   },
   {
    "p": "/construction-program-review-in-cambodia/",
    "t": "Construction Program Review in Cambodia"
   },
   {
    "p": "/construction-and-childcare-in-guatemala-review-by-lucy/",
    "t": "Construction and Childcare in Guatemala Review by Lucy"
   },
   {
    "p": "/construction-in-laos-review/",
    "t": "Construction in Laos Review"
   },
   {
    "p": "/construction-in-palawan-philippines-review/",
    "t": "Construction in Palawan Philippines Review"
   },
   {
    "p": "/construction-in-zanzibar-review/",
    "t": "Construction in Zanzibar Review"
   },
   {
    "p": "/construction-in-the-philippines-review/",
    "t": "Construction in the Philippines Review"
   },
   {
    "p": "/culture-week-nepal-testimonial/",
    "t": "Culture Week Nepal Testimonial"
   },
   {
    "p": "/dog-shelter-in-peru-review/",
    "t": "Dog Shelter in Peru Review"
   },
   {
    "p": "/donation-history/",
    "t": "Donation History"
   },
   {
    "p": "/eco-park-review-in-south-korea/",
    "t": "Eco Park Review in South Korea"
   },
   {
    "p": "/ellas-review-of-teaching-on-a-remote-island-in-fiji/",
    "t": "Ellas Review of Teaching on a Remote Island in Fiji"
   },
   {
    "p": "/elyses-review-of-construction-and-childcare-in-antigua/",
    "t": "Elyses Review of Construction and Childcare in Antigua"
   },
   {
    "p": "/english-teaching-fiji-review/",
    "t": "English Teaching Fiji Review"
   },
   {
    "p": "/english-teaching-philippines-review/",
    "t": "English Teaching Philippines Review"
   },
   {
    "p": "/english-teaching-in-bali-review/",
    "t": "English Teaching in Bali Review"
   },
   {
    "p": "/english-teaching-in-koh-samui-review/",
    "t": "English Teaching in Koh Samui Review"
   },
   {
    "p": "/english-teaching-in-ubud-bali-review/",
    "t": "English Teaching in Ubud Bali Review"
   },
   {
    "p": "/environmental-awareness-teaching-bali-review/",
    "t": "Environmental Awareness Teaching Bali Review"
   },
   {
    "p": "/environmental-english-teaching-review-from-bali/",
    "t": "Environmental English Teaching Review from Bali"
   },
   {
    "p": "/environmental-in-hua-hin-thailand-review/",
    "t": "Environmental in Hua Hin Thailand Review"
   },
   {
    "p": "/experience-and-feedback-guatemala-group-leader/",
    "t": "Experience and Feedback Guatemala Group Leader"
   },
   {
    "p": "/experience-of-india-28-day-road-trip/",
    "t": "Experience of India 28 Day Road Trip"
   },
   {
    "p": "/feedback-on-thailand-volunteering/",
    "t": "Feedback on Thailand Volunteering"
   },
   {
    "p": "/fiji-2024-nutrition-outreach-review/",
    "t": "Fiji 2024 Nutrition Outreach Review"
   },
   {
    "p": "/fiji-animals-review/",
    "t": "Fiji Animals Review"
   },
   {
    "p": "/fiji-construction-commune-review/",
    "t": "Fiji Construction Commune Review"
   },
   {
    "p": "/fiji-construction-project-review/",
    "t": "Fiji Construction Project Review"
   },
   {
    "p": "/fiji-health-education-review/",
    "t": "Fiji Health Education Review"
   },
   {
    "p": "/fiji-health-nutrition-program-review/",
    "t": "Fiji Health Nutrition Program Review"
   },
   {
    "p": "/fiji-healthcare-project-review/",
    "t": "Fiji Healthcare Project Review"
   },
   {
    "p": "/fiji-island-healthcare-testimony/",
    "t": "Fiji Island Healthcare Testimony"
   },
   {
    "p": "/fiji-island-teaching-testimony/",
    "t": "Fiji Island Teaching Testimony"
   },
   {
    "p": "/fiji-island-teaching-testimony-2/",
    "t": "Fiji Island Teaching Testimony 2"
   },
   {
    "p": "/fiji-islands-teaching-review/",
    "t": "Fiji Islands Teaching Review"
   },
   {
    "p": "/fiji-kindergarten-teaching-review/",
    "t": "Fiji Kindergarten Teaching Review"
   },
   {
    "p": "/fiji-nutrition-outreach-kindy-program-reviews/",
    "t": "Fiji Nutrition Outreach Kindy Program Reviews"
   },
   {
    "p": "/fiji-nutrition-outreach-review/",
    "t": "Fiji Nutrition Outreach Review"
   },
   {
    "p": "/fiji-nutrition-program-review/",
    "t": "Fiji Nutrition Program Review"
   },
   {
    "p": "/fiji-nutrition-project-review/",
    "t": "Fiji Nutrition Project Review"
   },
   {
    "p": "/fiji-nutrition-and-public-health-review/",
    "t": "Fiji Nutrition and Public Health Review"
   },
   {
    "p": "/fiji-orphanage-testimony-lucy-sharrock/",
    "t": "Fiji Orphanage Testimony Lucy Sharrock"
   },
   {
    "p": "/fiji-public-health-outreach-paramedic-review/",
    "t": "Fiji Public Health Outreach Paramedic Review"
   },
   {
    "p": "/fiji-public-health-outreach-review/",
    "t": "Fiji Public Health Outreach Review"
   },
   {
    "p": "/fiji-remote-construction-review-chris/",
    "t": "Fiji Remote Construction Review Chris"
   },
   {
    "p": "/fiji-remote-island-school-teaching-review/",
    "t": "Fiji Remote Island School Teaching Review"
   },
   {
    "p": "/fiji-remote-island-teaching-project-review/",
    "t": "Fiji Remote Island Teaching Project Review"
   },
   {
    "p": "/fiji-remote-island-teaching-and-orphanage-review/",
    "t": "Fiji Remote Island Teaching and Orphanage Review"
   },
   {
    "p": "/fiji-sigatoka-kindergarten-review/",
    "t": "Fiji Sigatoka Kindergarten Review"
   },
   {
    "p": "/fiji-suva-kindergarten-teaching-review/",
    "t": "Fiji Suva Kindergarten Teaching Review"
   },
   {
    "p": "/fiji-teaching-remote-island-review-maureen/",
    "t": "Fiji Teaching Remote Island Review Maureen"
   },
   {
    "p": "/fiji-volunteering-feedback/",
    "t": "Fiji Volunteering Feedback"
   },
   {
    "p": "/fiji-womens-commune-kindy-review/",
    "t": "Fiji Womens Commune Kindy Review"
   },
   {
    "p": "/food-shop-vietnam-review/",
    "t": "Food Shop Vietnam Review"
   },
   {
    "p": "/food-support-in-portugal-review/",
    "t": "Food Support in Portugal Review"
   },
   {
    "p": "/goa-community-support-project-review-from-india/",
    "t": "Goa Community Support Project Review from India"
   },
   {
    "p": "/goa-india-slum-outreach-review/",
    "t": "Goa India Slum Outreach Review"
   },
   {
    "p": "/health-clinic-volunteer-review-philippines/",
    "t": "Health Clinic Volunteer Review Philippines"
   },
   {
    "p": "/health-education-teaching-in-bali-review/",
    "t": "Health Education Teaching in Bali Review"
   },
   {
    "p": "/health-nutrition-philippines-review/",
    "t": "Health Nutrition Philippines Review"
   },
   {
    "p": "/health-teaching-in-bali-review/",
    "t": "Health Teaching in Bali Review"
   },
   {
    "p": "/healthcare-bali-education-review/",
    "t": "Healthcare Bali Education Review"
   },
   {
    "p": "/healthcare-education-bali-dietetics-student-review/",
    "t": "Healthcare Education Bali Dietetics Student Review"
   },
   {
    "p": "/healthcare-education-experience-bali/",
    "t": "Healthcare Education Experience Bali"
   },
   {
    "p": "/healthcare-in-the-philippines-review/",
    "t": "Healthcare in the Philippines Review"
   },
   {
    "p": "/hospital-internship-health-program-review/",
    "t": "Hospital Internship Health Program Review"
   },
   {
    "p": "/island-teaching-in-fiji-review/",
    "t": "Island Teaching in Fiji Review"
   },
   {
    "p": "/island-teaching-in-fiji-review-2/",
    "t": "Island Teaching in Fiji Review 2"
   },
   {
    "p": "/jasmin-review-primary-school-teaching-vanuatu/",
    "t": "Jasmin Review Primary School Teaching Vanuatu"
   },
   {
    "p": "/jasmins-review-on-teaching-in-vanuatu/",
    "t": "Jasmins Review on Teaching in Vanuatu"
   },
   {
    "p": "/kenya-teaching-project-review-irene/",
    "t": "Kenya Teaching Project Review Irene"
   },
   {
    "p": "/kenya-wildlife-conservation-review/",
    "t": "Kenya Wildlife Conservation Review"
   },
   {
    "p": "/kindergaren-teaching-review-from-chiang-mai-thailand/",
    "t": "Kindergaren Teaching Review from Chiang Mai Thailand"
   },
   {
    "p": "/kindergarten-project-nepal-review-monika/",
    "t": "Kindergarten Project Nepal Review Monika"
   },
   {
    "p": "/kindergarten-review-in-kenya/",
    "t": "Kindergarten Review in Kenya"
   },
   {
    "p": "/kindergarten-teaching-madagascar-review/",
    "t": "Kindergarten Teaching Madagascar Review"
   },
   {
    "p": "/kindergarten-teaching-support-in-fiji-review/",
    "t": "Kindergarten Teaching Support in Fiji Review"
   },
   {
    "p": "/kindergarten-teaching-ubud-bali-review/",
    "t": "Kindergarten Teaching Ubud Bali Review"
   },
   {
    "p": "/kindergarten-teaching-in-vietnam-experience/",
    "t": "Kindergarten Teaching in Vietnam Experience"
   },
   {
    "p": "/kindergarten-teaching-in-vietnam-experience-2/",
    "t": "Kindergarten Teaching in Vietnam Experience 2"
   },
   {
    "p": "/kindergarten-in-aborlan-philippines-review/",
    "t": "Kindergarten in Aborlan Philippines Review"
   },
   {
    "p": "/kindergarten-in-vietnam-review/",
    "t": "Kindergarten in Vietnam Review"
   },
   {
    "p": "/kindy-teaching-in-sigatoka-fiji-review/",
    "t": "Kindy Teaching in Sigatoka Fiji Review"
   },
   {
    "p": "/laos-kindergarten-program-review/",
    "t": "Laos Kindergarten Program Review"
   },
   {
    "p": "/laos-review-teaching-and-adventure-week/",
    "t": "Laos Review Teaching and Adventure Week"
   },
   {
    "p": "/lemur-conservation-madagascar-review/",
    "t": "Lemur Conservation Madagascar Review"
   },
   {
    "p": "/lombok-primary-school-teaching-review/",
    "t": "Lombok Primary School Teaching Review"
   },
   {
    "p": "/mangrove-conservation-review/",
    "t": "Mangrove Conservation Review"
   },
   {
    "p": "/marine-conservation-vanuatu-review/",
    "t": "Marine Conservation Vanuatu Review"
   },
   {
    "p": "/medical-internship-philippines-review/",
    "t": "Medical Internship Philippines Review"
   },
   {
    "p": "/medical-internship-in-leyte-philippiens-review/",
    "t": "Medical Internship in Leyte Philippiens Review"
   },
   {
    "p": "/medical-internship-in-vietnam-review/",
    "t": "Medical Internship in Vietnam Review"
   },
   {
    "p": "/medical-program-in-guatemala-review/",
    "t": "Medical Program in Guatemala Review"
   },
   {
    "p": "/medical-project-peru-review-by-victoria/",
    "t": "Medical Project Peru Review by Victoria"
   },
   {
    "p": "/medical-volunteer-review-kenya/",
    "t": "Medical Volunteer Review Kenya"
   },
   {
    "p": "/mother-2-year-old-son-volunteering-in-costa-rica-review/",
    "t": "Mother 2 Year Old Son Volunteering in Costa Rica Review"
   },
   {
    "p": "/mother-daughter-volunteers-elephant-care-in-thailand-review/",
    "t": "Mother Daughter Volunteers Elephant Care in Thailand Review"
   },
   {
    "p": "/mother-and-daughter-volunteering-in-fiji-review/",
    "t": "Mother and Daughter Volunteering in Fiji Review"
   },
   {
    "p": "/mount-everest-base-camp-trek-review/",
    "t": "Mount Everest Base Camp Trek Review"
   },
   {
    "p": "/my-experience-in-bali/",
    "t": "My Experience in Bali"
   },
   {
    "p": "/nepal-construction-review/",
    "t": "Nepal Construction Review"
   },
   {
    "p": "/nepal-dog-program-review/",
    "t": "Nepal Dog Program Review"
   },
   {
    "p": "/nepal-kindergarten-review/",
    "t": "Nepal Kindergarten Review"
   },
   {
    "p": "/nepal-kindergarten-volunteering-feedback/",
    "t": "Nepal Kindergarten Volunteering Feedback"
   },
   {
    "p": "/nepal-medical-internship-review/",
    "t": "Nepal Medical Internship Review"
   },
   {
    "p": "/nepal-physiotherapy-hospital-internship-review/",
    "t": "Nepal Physiotherapy Hospital Internship Review"
   },
   {
    "p": "/nepal-volunteer-interview/",
    "t": "Nepal Volunteer Interview"
   },
   {
    "p": "/nepal-volunteer-kindergarten-teaching-review/",
    "t": "Nepal Volunteer Kindergarten Teaching Review"
   },
   {
    "p": "/nursing-public-health-program-fiji-review/",
    "t": "Nursing Public Health Program Fiji Review"
   },
   {
    "p": "/nutrition-education-bali-review/",
    "t": "Nutrition Education Bali Review"
   },
   {
    "p": "/nutrition-education-program-bali-review/",
    "t": "Nutrition Education Program Bali Review"
   },
   {
    "p": "/nutrition-education-in-bali-review/",
    "t": "Nutrition Education in Bali Review"
   },
   {
    "p": "/nutrition-health-fiji-review-ella/",
    "t": "Nutrition Health Fiji Review Ella"
   },
   {
    "p": "/nutrition-health-review-valerie/",
    "t": "Nutrition Health Review Valerie"
   },
   {
    "p": "/nutrition-outreach-in-fiji-review/",
    "t": "Nutrition Outreach in Fiji Review"
   },
   {
    "p": "/nutrition-program-review-fiji/",
    "t": "Nutrition Program Review Fiji"
   },
   {
    "p": "/nutrition-project-philippines-review-2/",
    "t": "Nutrition Project Philippines Review 2"
   },
   {
    "p": "/nutrition-project-review-fiji/",
    "t": "Nutrition Project Review Fiji"
   },
   {
    "p": "/nutrition-public-health-2019-review/",
    "t": "Nutrition Public Health 2019 Review"
   },
   {
    "p": "/nutrition-public-health-review-by-holly/",
    "t": "Nutrition Public Health Review by Holly"
   },
   {
    "p": "/nutrition-and-healthcare-education-in-bali-ubud-review/",
    "t": "Nutrition and Healthcare Education in Bali Ubud Review"
   },
   {
    "p": "/nutrition-in-fiji-whats-it-like-a-review-by-marina/",
    "t": "Nutrition in Fiji Whats It Like a Review by Marina"
   },
   {
    "p": "/orphanage-project-ivi-review-philippines/",
    "t": "Orphanage Project IVI Review Philippines"
   },
   {
    "p": "/philippines-environmental-conservation-review/",
    "t": "Philippines Environmental Conservation Review"
   },
   {
    "p": "/philippines-teaching-review/",
    "t": "Philippines Teaching Review"
   },
   {
    "p": "/primary-school-teaching-sigatoka-review/",
    "t": "Primary School Teaching Sigatoka Review"
   },
   {
    "p": "/primary-school-teaching-thailand-review/",
    "t": "Primary School Teaching Thailand Review"
   },
   {
    "p": "/public-health-nutrition-review-ben/",
    "t": "Public Health Nutrition Review Ben"
   },
   {
    "p": "/public-health-nutrition-review-marley/",
    "t": "Public Health Nutrition Review Marley"
   },
   {
    "p": "/public-health-outreach-review-fiji/",
    "t": "Public Health Outreach Review Fiji"
   },
   {
    "p": "/public-health-outreach-in-fiji-review/",
    "t": "Public Health Outreach in Fiji Review"
   },
   {
    "p": "/public-health-vanuatu-review-2019/",
    "t": "Public Health Vanuatu Review 2019"
   },
   {
    "p": "/public-health-and-nutrition-review-vanuatu/",
    "t": "Public Health and Nutrition Review Vanuatu"
   },
   {
    "p": "/public-health-in-fiji-review/",
    "t": "Public Health in Fiji Review"
   },
   {
    "p": "/refugee-camp-review-greece/",
    "t": "Refugee Camp Review Greece"
   },
   {
    "p": "/refugee-support-turkey-review/",
    "t": "Refugee Support Turkey Review"
   },
   {
    "p": "/remote-fiji-island-review-by-pia/",
    "t": "Remote Fiji Island Review by Pia"
   },
   {
    "p": "/remote-island-review-fiji/",
    "t": "Remote Island Review Fiji"
   },
   {
    "p": "/remote-island-school-project-review-from-fiji/",
    "t": "Remote Island School Project Review from Fiji"
   },
   {
    "p": "/remote-island-teaching-fiji-review/",
    "t": "Remote Island Teaching Fiji Review"
   },
   {
    "p": "/remote-island-teaching-fiji-review-megan/",
    "t": "Remote Island Teaching Fiji Review Megan"
   },
   {
    "p": "/remote-island-teaching-review/",
    "t": "Remote Island Teaching Review"
   },
   {
    "p": "/remote-island-teaching-review-alex/",
    "t": "Remote Island Teaching Review Alex"
   },
   {
    "p": "/remote-island-teaching-review-from-fiji/",
    "t": "Remote Island Teaching Review from Fiji"
   },
   {
    "p": "/remote-island-in-fiji-review/",
    "t": "Remote Island in Fiji Review"
   },
   {
    "p": "/remote-teaching-in-fiji-review/",
    "t": "Remote Teaching in Fiji Review"
   },
   {
    "p": "/review-construction-in-el-nido-and-aborlan-philippines/",
    "t": "Review Construction in El Nido and Aborlan Philippines"
   },
   {
    "p": "/review-elephant-conservation-koh-samui/",
    "t": "Review Elephant Conservation Koh Samui"
   },
   {
    "p": "/review-form/",
    "t": "Review Form"
   },
   {
    "p": "/review-north-qld-zoo/",
    "t": "Review North QLD Zoo"
   },
   {
    "p": "/review-nutrition-program-bali/",
    "t": "Review Nutrition Program Bali"
   },
   {
    "p": "/review-nutrition-public-health-outreach-fiji/",
    "t": "Review Nutrition Public Health Outreach Fiji"
   },
   {
    "p": "/review-remote-and-island-teaching-and-orphanage-in-fiji/",
    "t": "Review Remote and Island Teaching and Orphanage in Fiji"
   },
   {
    "p": "/review-renovation-construction-support-in-goa-india/",
    "t": "Review Renovation Construction Support in Goa India"
   },
   {
    "p": "/review-sports-and-kindergarten-fun-at-sigatoka/",
    "t": "Review Sports and Kindergarten Fun at Sigatoka"
   },
   {
    "p": "/review-turtle-conservation-nusa-penida/",
    "t": "Review Turtle Conservation Nusa Penida"
   },
   {
    "p": "/review-wildlife-conservation-kenya/",
    "t": "Review Wildlife Conservation Kenya"
   },
   {
    "p": "/review-of-alpaca-farm-in-peru/",
    "t": "Review of Alpaca Farm in Peru"
   },
   {
    "p": "/review-of-bali-health-teaching-project/",
    "t": "Review of Bali Health Teaching Project"
   },
   {
    "p": "/review-of-construction-in-kathmandu-nepal/",
    "t": "Review of Construction in Kathmandu Nepal"
   },
   {
    "p": "/review-of-elephant-conservation-program-in-chiang-mai-thailand/",
    "t": "Review of Elephant Conservation Program in Chiang Mai Thailand"
   },
   {
    "p": "/review-of-food-security-farming-in-kenya/",
    "t": "Review of Food Security Farming in Kenya"
   },
   {
    "p": "/review-of-indigenous-community-project-peru/",
    "t": "Review of Indigenous Community Project Peru"
   },
   {
    "p": "/review-of-kindergarten-project-in-ubud/",
    "t": "Review of Kindergarten Project in Ubud"
   },
   {
    "p": "/review-of-kindergarten-in-chiang-mai-thailand/",
    "t": "Review of Kindergarten in Chiang Mai Thailand"
   },
   {
    "p": "/review-of-nepal-culture-week-intro/",
    "t": "Review of Nepal Culture Week Intro"
   },
   {
    "p": "/review-of-nutrition-projects-in-fiji/",
    "t": "Review of Nutrition Projects in Fiji"
   },
   {
    "p": "/review-of-orphanage-in-nadi-fiji/",
    "t": "Review of Orphanage in Nadi Fiji"
   },
   {
    "p": "/review-of-remote-island-teaching-in-fiji/",
    "t": "Review of Remote Island Teaching in Fiji"
   },
   {
    "p": "/review-of-stray-dog-rehabilitation-nepal/",
    "t": "Review of Stray Dog Rehabilitation Nepal"
   },
   {
    "p": "/review-of-teaching-in-madagascar/",
    "t": "Review of Teaching in Madagascar"
   },
   {
    "p": "/review-of-teaching-in-monduli-tanzania/",
    "t": "Review of Teaching in Monduli Tanzania"
   },
   {
    "p": "/review-of-the-refugee-support-program-in-turkey/",
    "t": "Review of the Refugee Support Program in Turkey"
   },
   {
    "p": "/rural-india-school-teaching-review/",
    "t": "Rural India School Teaching Review"
   },
   {
    "p": "/rural-primary-school-cambodia-feedback/",
    "t": "Rural Primary School Cambodia Feedback"
   },
   {
    "p": "/rural-school-teaching-cambodia-feedback/",
    "t": "Rural School Teaching Cambodia Feedback"
   },
   {
    "p": "/siem-ream-cambodia-teaching-review/",
    "t": "Siem Ream Cambodia Teaching Review"
   },
   {
    "p": "/south-korea-childcare-and-after-school-support-program-review/",
    "t": "South Korea Childcare and After School Support Program Review"
   },
   {
    "p": "/special-needs-village-kids-teaching-review-sri-lanka/",
    "t": "Special Needs Village Kids Teaching Review Sri Lanka"
   },
   {
    "p": "/sports-coaching-in-fiji-review/",
    "t": "Sports Coaching in Fiji Review"
   },
   {
    "p": "/sports-teaching-fiji-review/",
    "t": "Sports Teaching Fiji Review"
   },
   {
    "p": "/sri-lanka-review-ella-daniela/",
    "t": "Sri Lanka Review Ella Daniela"
   },
   {
    "p": "/sri-lanka-special-needs-review-by-arden/",
    "t": "Sri Lanka Special Needs Review by Arden"
   },
   {
    "p": "/sri-lanka-turtle-conservation-review/",
    "t": "Sri Lanka Turtle Conservation Review"
   },
   {
    "p": "/sri-lanka-turtle-conservation-review-2/",
    "t": "Sri Lanka Turtle Conservation Review 2"
   },
   {
    "p": "/storytelling-lemur-conservation-with-toni/",
    "t": "Storytelling Lemur Conservation with Toni"
   },
   {
    "p": "/stray-dog-rehabilitation-review/",
    "t": "Stray Dog Rehabilitation Review"
   },
   {
    "p": "/stray-dog-rehabilitation-review-nepal/",
    "t": "Stray Dog Rehabilitation Review Nepal"
   },
   {
    "p": "/successful-homestays-true-volunteer-experience/",
    "t": "Successful Homestays True Volunteer Experience"
   },
   {
    "p": "/tanzania-maasai-community-support-review/",
    "t": "Tanzania Maasai Community Support Review"
   },
   {
    "p": "/tanzania-teaching-review/",
    "t": "Tanzania Teaching Review"
   },
   {
    "p": "/teaching-children-bali-review/",
    "t": "Teaching Children Bali Review"
   },
   {
    "p": "/teaching-children-thailand-review/",
    "t": "Teaching Children Thailand Review"
   },
   {
    "p": "/teaching-english-in-bali-review/",
    "t": "Teaching English in Bali Review"
   },
   {
    "p": "/teaching-english-in-manuel-antonio-costa-rica-review/",
    "t": "Teaching English in Manuel Antonio Costa Rica Review"
   },
   {
    "p": "/teaching-english-in-sigatoka-fiji-testimonial/",
    "t": "Teaching English in Sigatoka Fiji Testimonial"
   },
   {
    "p": "/teaching-nepal-review-by-maria/",
    "t": "Teaching Nepal Review by Maria"
   },
   {
    "p": "/teaching-in-chiang-mai-thailand-review/",
    "t": "Teaching in Chiang Mai Thailand Review"
   },
   {
    "p": "/teaching-in-fiji-review/",
    "t": "Teaching in Fiji Review"
   },
   {
    "p": "/teaching-in-kenya-experience/",
    "t": "Teaching in Kenya Experience"
   },
   {
    "p": "/teaching-in-kenya-review-ana/",
    "t": "Teaching in Kenya Review Ana"
   },
   {
    "p": "/teaching-in-peru-review/",
    "t": "Teaching in Peru Review"
   },
   {
    "p": "/teaching-in-peru-review-2/",
    "t": "Teaching in Peru Review 2"
   },
   {
    "p": "/teaching-in-thailand-review/",
    "t": "Teaching in Thailand Review"
   },
   {
    "p": "/teaching-in-zanzibar-tanzania-review/",
    "t": "Teaching in Zanzibar Tanzania Review"
   },
   {
    "p": "/temple-restoration-review-by-mary/",
    "t": "Temple Restoration Review by Mary"
   },
   {
    "p": "/ten-minutes-experience-naturopath-fiji/",
    "t": "Ten Minutes Experience Naturopath Fiji"
   },
   {
    "p": "/thailand-construction-and-renovation-review/",
    "t": "Thailand Construction and Renovation Review"
   },
   {
    "p": "/thailand-school-construction-in-hua-hin-review/",
    "t": "Thailand School Construction in Hua Hin Review"
   },
   {
    "p": "/thailand-volunteering-feedback/",
    "t": "Thailand Volunteering Feedback"
   },
   {
    "p": "/turtle-conservation-bali-review/",
    "t": "Turtle Conservation Bali Review"
   },
   {
    "p": "/turtle-conservation-indonesia-review/",
    "t": "Turtle Conservation Indonesia Review"
   },
   {
    "p": "/turtle-conservation-nusa-penida-review/",
    "t": "Turtle Conservation Nusa Penida Review"
   },
   {
    "p": "/turtle-conservation-review-in-bali/",
    "t": "Turtle Conservation Review in Bali"
   },
   {
    "p": "/turtle-conservation-review-in-nusa-penida/",
    "t": "Turtle Conservation Review in Nusa Penida"
   },
   {
    "p": "/turtle-conservation-in-indonesia-review/",
    "t": "Turtle Conservation in Indonesia Review"
   },
   {
    "p": "/turtle-conservation-in-nusa-penida-bali-review/",
    "t": "Turtle Conservation in Nusa Penida Bali Review"
   },
   {
    "p": "/turtle-conservation-in-nusa-penida-review/",
    "t": "Turtle Conservation in Nusa Penida Review"
   },
   {
    "p": "/turtle-conservation-in-nusa-penida-review-2/",
    "t": "Turtle Conservation in Nusa Penida Review 2"
   },
   {
    "p": "/turtle-conservation-in-sri-lanka-review/",
    "t": "Turtle Conservation in Sri Lanka Review"
   },
   {
    "p": "/turtle-program-in-bali-review/",
    "t": "Turtle Program in Bali Review"
   },
   {
    "p": "/turtle-program-in-bali-review-2/",
    "t": "Turtle Program in Bali Review 2"
   },
   {
    "p": "/vanuatu-nutrition-outreach-review-2019/",
    "t": "Vanuatu Nutrition Outreach Review 2019"
   },
   {
    "p": "/vanuatu-public-health-nutrition-review-2019/",
    "t": "Vanuatu Public Health Nutrition Review 2019"
   },
   {
    "p": "/vanuatu-public-health-nutrition-review-sonia/",
    "t": "Vanuatu Public Health Nutrition Review Sonia"
   },
   {
    "p": "/vanuatu-review/",
    "t": "Vanuatu Review"
   },
   {
    "p": "/vanuatu-review-father-son-teaching/",
    "t": "Vanuatu Review Father Son Teaching"
   },
   {
    "p": "/vanuatu-review-lily/",
    "t": "Vanuatu Review Lily"
   },
   {
    "p": "/vietnam-food-shop-review/",
    "t": "Vietnam Food Shop Review"
   },
   {
    "p": "/vietnam-medical-volunteer-review/",
    "t": "Vietnam Medical Volunteer Review"
   },
   {
    "p": "/volunteer-review-sri-lanka/",
    "t": "Volunteer Review Sri Lanka"
   },
   {
    "p": "/volunteer-story-nepal-experience/",
    "t": "Volunteer Story Nepal Experience"
   },
   {
    "p": "/volunteer-in-fiji-with-ivi-for-a-unique-experience/",
    "t": "Volunteer in Fiji with IVI for a Unique Experience"
   },
   {
    "p": "/volunteering-abroad-with-no-experience-a-full-comparison-guide/",
    "t": "Volunteering Abroad with No Experience a Full Comparison Guide"
   },
   {
    "p": "/volunteering-bodhgaya-india-review-2016/",
    "t": "Volunteering Bodhgaya India Review 2016"
   },
   {
    "p": "/women-childrens-commune-review-fiji/",
    "t": "Women Childrens Commune Review Fiji"
   },
   {
    "p": "/women-empowerment-program-review-in-nepal/",
    "t": "Women Empowerment Program Review in Nepal"
   },
   {
    "p": "/women-empowerment-review-nepal/",
    "t": "Women Empowerment Review Nepal"
   }
  ]
 },
 {
  "key": "blog",
  "label": "Guides, Tips & Blog",
  "items": [
   {
    "p": "/10-amazing-benefits-of-volunteering-overseas/",
    "t": "10 Amazing Benefits of Volunteering Overseas"
   },
   {
    "p": "/10-destinations-for-volunteering-abroad/",
    "t": "10 Destinations for Volunteering Abroad"
   },
   {
    "p": "/10-reasons-why-volunteering-at-the-bodhi-tree-school-india-will-change-your-life/",
    "t": "10 Reasons Why Volunteering at the Bodhi Tree School India Will Change your Life"
   },
   {
    "p": "/10-reasons-why-you-should-volunteer-abroad-at-christmas/",
    "t": "10 Reasons Why you Should Volunteer Abroad at Christmas"
   },
   {
    "p": "/11-awesome-tefl-esl-games-for-teaching-kids-abroad/",
    "t": "11 Awesome TEFL ESL Games for Teaching Kids Abroad"
   },
   {
    "p": "/11-ways-you-can-help-at-the-bodhi-tree-school-in-india/",
    "t": "11 Ways you Can Help at the Bodhi Tree School in India"
   },
   {
    "p": "/12-top-myths-about-volunteering-abroad-debunked/",
    "t": "12 Top Myths About Volunteering Abroad Debunked"
   },
   {
    "p": "/15-tablets-donated-island-schools/",
    "t": "15 Tablets Donated Island Schools"
   },
   {
    "p": "/15-things-to-do-in-koh-samui-our-new-volunteer-destination/",
    "t": "15 Things to Do in Koh Samui Our New Volunteer Destination"
   },
   {
    "p": "/20-awesome-things-to-do-in-san-jose-costa-rica/",
    "t": "20 Awesome Things to Do in San Jose Costa Rica"
   },
   {
    "p": "/21-day-fiji-road-trip-2016/",
    "t": "21 Day Fiji Road Trip 2016"
   },
   {
    "p": "/5-reasons-volunteer-boghgaya/",
    "t": "5 Reasons Volunteer Boghgaya"
   },
   {
    "p": "/5-ways-volunteering-abroad-will-change-better/",
    "t": "5 Ways Volunteering Abroad Will Change Better"
   },
   {
    "p": "/6-reasons-volunteer-philippines/",
    "t": "6 Reasons Volunteer Philippines"
   },
   {
    "p": "/6-reasons-why-volunteering-in-tanzania-should-be-your-next-trip/",
    "t": "6 Reasons Why Volunteering in Tanzania Should Be your Next Trip"
   },
   {
    "p": "/7-best-construction-projects-abroad-this-year/",
    "t": "7 Best Construction Projects Abroad This Year"
   },
   {
    "p": "/7-best-volunteer-abroad-programs-for-a-longer-duration/",
    "t": "7 Best Volunteer Abroad Programs for a Longer Duration"
   },
   {
    "p": "/7-best-wildlife-conservation-projects-abroad-for-2022-and-2023/",
    "t": "7 Best Wildlife Conservation Projects Abroad for 2022 and 2023"
   },
   {
    "p": "/7-reasons-why-you-should-volunteer-in-peru-in-2023/",
    "t": "7 Reasons Why you Should Volunteer in Peru in 2023"
   },
   {
    "p": "/7-signs-you-need-to-volunteer-abroad/",
    "t": "7 Signs you Need to Volunteer Abroad"
   },
   {
    "p": "/8-reasons-to-volunteer-in-costa-rica/",
    "t": "8 Reasons to Volunteer in Costa Rica"
   },
   {
    "p": "/a-beginners-guide-to-volunteering-abroad-how-to-get-started/",
    "t": "A Beginners Guide to Volunteering Abroad How to Get Started"
   },
   {
    "p": "/a-day-in-the-life-of-an-ivi-volunteer-in-fiji/",
    "t": "A Day in the Life of an IVI Volunteer in Fiji"
   },
   {
    "p": "/a-guide-to-solo-female-travel-volunteering-overseas/",
    "t": "A Guide to Solo Female Travel Volunteering Overseas"
   },
   {
    "p": "/a-step-by-step-guide-to-your-volunteer-trip-with-involvement-volunteers-international/",
    "t": "A Step by Step Guide to your Volunteer Trip with Involvement Volunteers International"
   },
   {
    "p": "/a-walk-with-a-local-rural-kenya/",
    "t": "A Walk with a Local Rural Kenya"
   },
   {
    "p": "/about-ivis-health-check-work-with-fiji-housing-developments/",
    "t": "About IVI's Health Check Work with Fiji Housing Developments"
   },
   {
    "p": "/adventure-travel-programs/",
    "t": "Adventure Travel Programs"
   },
   {
    "p": "/adventure-weeks/",
    "t": "Adventure Weeks"
   },
   {
    "p": "/affordable-volunteer-abroad-programs-a-full-comparison/",
    "t": "Affordable Volunteer Abroad Programs a Full Comparison"
   },
   {
    "p": "/animal-shelter-fiji/",
    "t": "Animal Shelter Fiji"
   },
   {
    "p": "/animal-shelter-fiji-2019/",
    "t": "Animal Shelter Fiji 2019"
   },
   {
    "p": "/animal-shelter-volunteering-fiji-2015/",
    "t": "Animal Shelter Volunteering Fiji 2015"
   },
   {
    "p": "/application-thank-you/",
    "t": "Application Thank you"
   },
   {
    "p": "/application-thank-you-pending/",
    "t": "Application Thank you Pending"
   },
   {
    "p": "/are-volunteer-abroad-programs-legit-a-full-comparison-guide/",
    "t": "Are Volunteer Abroad Programs Legit a Full Comparison Guide"
   },
   {
    "p": "/volunteer-overseas/asia/",
    "t": "Asia"
   },
   {
    "p": "/australia-north-qld/",
    "t": "Australia North QLD"
   },
   {
    "p": "/australia-north-qld-2/",
    "t": "Australia North QLD 2"
   },
   {
    "p": "/australia-north-qld-2-2/",
    "t": "Australia North QLD 2 2"
   },
   {
    "p": "/australia-zoo-volunteering/",
    "t": "Australia Zoo Volunteering"
   },
   {
    "p": "/bali-construction-program-2016/",
    "t": "Bali Construction Program 2016"
   },
   {
    "p": "/bali-health-education/",
    "t": "Bali Health Education"
   },
   {
    "p": "/benefits-and-tips-for-volunteering-overseas-for-under-17s/",
    "t": "Benefits and Tips for Volunteering Overseas for Under 17s"
   },
   {
    "p": "/benefits-of-taking-a-volunteer-gap-year/",
    "t": "Benefits of Taking a Volunteer Gap Year"
   },
   {
    "p": "/benefits-of-taking-a-volunteer-gap-year-why-is-it-so-amazing/",
    "t": "Benefits of Taking a Volunteer Gap Year Why Is It So Amazing"
   },
   {
    "p": "/benefits-of-volunteering-abroad-as-a-mature-volunteer/",
    "t": "Benefits of Volunteering Abroad as a Mature Volunteer"
   },
   {
    "p": "/benefits-of-volunteering-abroad-at-christmas/",
    "t": "Benefits of Volunteering Abroad at Christmas"
   },
   {
    "p": "/best-agriculture-and-farming-programs-abroad-for-this-year/",
    "t": "Best Agriculture and Farming Programs Abroad for This Year"
   },
   {
    "p": "/best-childcare-volunteer-programs-abroad-a-full-comparison/",
    "t": "Best Childcare Volunteer Programs Abroad a Full Comparison"
   },
   {
    "p": "/best-community-development-volunteer-programs-a-full-comparison/",
    "t": "Best Community Development Volunteer Programs a Full Comparison"
   },
   {
    "p": "/best-construction-projects-in-africa-involvement-volunteers-australia/",
    "t": "Best Construction Projects in Africa Involvement Volunteers Australia"
   },
   {
    "p": "/best-construction-projects-in-bali-involvement-volunteers-australia/",
    "t": "Best Construction Projects in Bali Involvement Volunteers Australia"
   },
   {
    "p": "/best-construction-projects-in-fiji-involvement-volunteers-australia/",
    "t": "Best Construction Projects in Fiji Involvement Volunteers Australia"
   },
   {
    "p": "/best-english-teaching-volunteer-program-in-vietnam-involvement-volunteers-international/",
    "t": "Best English Teaching Volunteer Program in Vietnam Involvement Volunteers International"
   },
   {
    "p": "/best-english-teaching-in-africa-involvement-volunteers-australia/",
    "t": "Best English Teaching in Africa Involvement Volunteers Australia"
   },
   {
    "p": "/best-english-teaching-in-bali-involvement-volunteers-australia/",
    "t": "Best English Teaching in Bali Involvement Volunteers Australia"
   },
   {
    "p": "/best-english-teaching-in-fiji-involvement-volunteers-australia/",
    "t": "Best English Teaching in Fiji Involvement Volunteers Australia"
   },
   {
    "p": "/best-environmental-conservation-volunteer-programs-a-full-comparison/",
    "t": "Best Environmental Conservation Volunteer Programs a Full Comparison"
   },
   {
    "p": "/best-gap-year-volunteer-programs-a-full-comparison/",
    "t": "Best Gap Year Volunteer Programs a Full Comparison"
   },
   {
    "p": "/best-gap-year-volunteer-programs-for-solo-travellers/",
    "t": "Best Gap Year Volunteer Programs for Solo Travellers"
   },
   {
    "p": "/best-group-volunteer-programs-abroad-a-full-comparison/",
    "t": "Best Group Volunteer Programs Abroad a Full Comparison"
   },
   {
    "p": "/best-kindergarten-volunteer-programs-with-ivi-this-year/",
    "t": "Best Kindergarten Volunteer Programs with IVI This Year"
   },
   {
    "p": "/best-medical-internship-in-india-involvement-volunteers-australia/",
    "t": "Best Medical Internship in India Involvement Volunteers Australia"
   },
   {
    "p": "/best-medical-volunteer-programs-abroad-a-full-comparison/",
    "t": "Best Medical Volunteer Programs Abroad a Full Comparison"
   },
   {
    "p": "/best-nutrition-and-public-health-volunteering-in-africa-involvement-volunteers-australia/",
    "t": "Best Nutrition and Public Health Volunteering in Africa Involvement Volunteers Australia"
   },
   {
    "p": "/best-nutrition-and-public-health-volunteering-in-bali-involvement-volunteers-australia/",
    "t": "Best Nutrition and Public Health Volunteering in Bali Involvement Volunteers Australia"
   },
   {
    "p": "/best-nutrition-and-public-health-volunteering-in-fiji-involvement-volunteers-australia/",
    "t": "Best Nutrition and Public Health Volunteering in Fiji Involvement Volunteers Australia"
   },
   {
    "p": "/best-nutrition-and-public-health-volunteering-in-thailand-involvement-volunteers-australia/",
    "t": "Best Nutrition and Public Health Volunteering in Thailand Involvement Volunteers Australia"
   },
   {
    "p": "/best-off-the-beaten-track-destinations-for-volunteering-abroad/",
    "t": "Best Off the Beaten Track Destinations for Volunteering Abroad"
   },
   {
    "p": "/best-places-to-volunteer-abroad-by-season/",
    "t": "Best Places to Volunteer Abroad by Season"
   },
   {
    "p": "/best-remote-island-teaching-in-fiji-involvement-volunteers-australia/",
    "t": "Best Remote Island Teaching in Fiji Involvement Volunteers Australia"
   },
   {
    "p": "/best-rural-teaching-program-in-china-involvement-volunteers-australia/",
    "t": "Best Rural Teaching Program in China Involvement Volunteers Australia"
   },
   {
    "p": "/best-short-term-volunteer-programs-abroad-a-full-comparison/",
    "t": "Best Short Term Volunteer Programs Abroad a Full Comparison"
   },
   {
    "p": "/best-spiritual-volunteer-programs-with-ivi/",
    "t": "Best Spiritual Volunteer Programs with IVI"
   },
   {
    "p": "/best-sports-coaching-abroad-projects-with-ivi/",
    "t": "Best Sports Coaching Abroad Projects with IVI"
   },
   {
    "p": "/best-sports-coaching-program-in-thailand/",
    "t": "Best Sports Coaching Program in Thailand"
   },
   {
    "p": "/best-teaching-volunteer-programs-abroad-a-full-comparison/",
    "t": "Best Teaching Volunteer Programs Abroad a Full Comparison"
   },
   {
    "p": "/best-things-to-do-in-seoul-south-korea/",
    "t": "Best Things to Do in Seoul South Korea"
   },
   {
    "p": "/best-things-to-do-on-chios-island-greece/",
    "t": "Best Things to Do on Chios Island Greece"
   },
   {
    "p": "/best-turtle-rehabilitation-in-sri-lanka-involvement-volunteers-australia/",
    "t": "Best Turtle Rehabilitation in Sri Lanka Involvement Volunteers Australia"
   },
   {
    "p": "/best-volunteer-abroad-programs/",
    "t": "Best Volunteer Abroad Programs"
   },
   {
    "p": "/best-volunteer-abroad-programs-for-18-25-year-olds-a-full-comparison/",
    "t": "Best Volunteer Abroad Programs for 18 25 Year Olds a Full Comparison"
   },
   {
    "p": "/best-volunteer-abroad-programs-for-first-time-volunteers-a-full-comparison/",
    "t": "Best Volunteer Abroad Programs for First Time Volunteers a Full Comparison"
   },
   {
    "p": "/best-volunteer-abroad-programs-for-solo-travellers-a-full-comparison/",
    "t": "Best Volunteer Abroad Programs for Solo Travellers a Full Comparison"
   },
   {
    "p": "/best-volunteer-abroad-programs-for-university-students-a-full-comparison/",
    "t": "Best Volunteer Abroad Programs for University Students a Full Comparison"
   },
   {
    "p": "/best-volunteer-destinations-for-solo-female-travellers/",
    "t": "Best Volunteer Destinations for Solo Female Travellers"
   },
   {
    "p": "/best-volunteer-programs-in-africa-a-full-comparison/",
    "t": "Best Volunteer Programs in Africa a Full Comparison"
   },
   {
    "p": "/best-volunteer-programs-in-africa-with-ivi/",
    "t": "Best Volunteer Programs in Africa with IVI"
   },
   {
    "p": "/best-volunteer-programs-in-asia-a-full-comparison/",
    "t": "Best Volunteer Programs in Asia a Full Comparison"
   },
   {
    "p": "/best-volunteer-programs-in-ecuador-in-2024/",
    "t": "Best Volunteer Programs in Ecuador in 2024"
   },
   {
    "p": "/best-volunteer-programs-in-south-america-a-full-comparison/",
    "t": "Best Volunteer Programs in South America a Full Comparison"
   },
   {
    "p": "/best-volunteer-projects-in-the-south-pacific/",
    "t": "Best Volunteer Projects in the South Pacific"
   },
   {
    "p": "/best-volunteer-teaching-programs-with-ivi-in-2024/",
    "t": "Best Volunteer Teaching Programs with IVI in 2024"
   },
   {
    "p": "/best-way-to-volunteer-vietnam/",
    "t": "Best Way to Volunteer Vietnam"
   },
   {
    "p": "/best-way-to-volunteer-and-build-in-fiji-involvement-volunteers-australia/",
    "t": "Best Way to Volunteer and Build in Fiji Involvement Volunteers Australia"
   },
   {
    "p": "/best-wildlife-conservation-volunteer-programs-a-full-comparison/",
    "t": "Best Wildlife Conservation Volunteer Programs a Full Comparison"
   },
   {
    "p": "/best-wildlife-volunteer-projects-with-involvement-volunteers/",
    "t": "Best Wildlife Volunteer Projects with Involvement Volunteers"
   },
   {
    "p": "/best-wildlife-and-marine-volunteer-programs-with-ivi/",
    "t": "Best Wildlife and Marine Volunteer Programs with IVI"
   },
   {
    "p": "/blog/",
    "t": "Blog"
   },
   {
    "p": "/bodhgaya-india-faq-for-female-volunteers/",
    "t": "Bodhgaya India FAQ for Female Volunteers"
   },
   {
    "p": "/budgeting-and-funding-for-volunteering-abroad/",
    "t": "Budgeting and Funding for Volunteering Abroad"
   },
   {
    "p": "/cambodia-medical-hospital-volunteering-2015/",
    "t": "Cambodia Medical Hospital Volunteering 2015"
   },
   {
    "p": "/challenges-and-rewards-of-volunteering-abroad/",
    "t": "Challenges and Rewards of Volunteering Abroad"
   },
   {
    "p": "/checkout/",
    "t": "Checkout"
   },
   {
    "p": "/childcare-and-construction-volunteering-sri-lanka/",
    "t": "Childcare and Construction Volunteering Sri Lanka"
   },
   {
    "p": "/coming-soon/",
    "t": "Coming Soon"
   },
   {
    "p": "/community-construction-nepal-2018/",
    "t": "Community Construction Nepal 2018"
   },
   {
    "p": "/community-support-programs/",
    "t": "Community Support Programs"
   },
   {
    "p": "/community-volunteering-nepal-2015/",
    "t": "Community Volunteering Nepal 2015"
   },
   {
    "p": "/coronavirus-update/",
    "t": "Coronavirus Update"
   },
   {
    "p": "/costa-rica-manuel-antonio-or-san-jose/",
    "t": "Costa Rica Manuel Antonio or San Jose"
   },
   {
    "p": "/country-specific-faq/",
    "t": "Country Specific FAQ"
   },
   {
    "p": "/cpd-points/",
    "t": "Cpd Points"
   },
   {
    "p": "/creative-teaching-activities-for-kids-while-volunteering-abroad/",
    "t": "Creative Teaching Activities for Kids While Volunteering Abroad"
   },
   {
    "p": "/criminal-background-checks/",
    "t": "Criminal Background Checks"
   },
   {
    "p": "/cultural-immersion-programs-abroad-with-ivi/",
    "t": "Cultural Immersion Programs Abroad with IVI"
   },
   {
    "p": "/cultural-orientation-programs/",
    "t": "Cultural Orientation Programs"
   },
   {
    "p": "/cyclone-harold-can-you-help/",
    "t": "Cyclone Harold Can you Help"
   },
   {
    "p": "/cyclone-harold-emergency-relief-vanuatu/",
    "t": "Cyclone Harold Emergency Relief Vanuatu"
   },
   {
    "p": "/cyclone-winston-did-i-help/",
    "t": "Cyclone Winston Did I Help"
   },
   {
    "p": "/cyclone-winston-disaster-relief-fiji-2016/",
    "t": "Cyclone Winston Disaster Relief Fiji 2016"
   },
   {
    "p": "/cyclone-winston-disaster-relief-fiji-2016-2/",
    "t": "Cyclone Winston Disaster Relief Fiji 2016 2"
   },
   {
    "p": "/cyclone-winston-disaster-relief-fiji-2016-3/",
    "t": "Cyclone Winston Disaster Relief Fiji 2016 3"
   },
   {
    "p": "/cyclone-winston-disaster-relief-fiji-blog/",
    "t": "Cyclone Winston Disaster Relief Fiji Blog"
   },
   {
    "p": "/deposit/",
    "t": "Deposit"
   },
   {
    "p": "/diploma-in-international-volunteering/",
    "t": "Diploma in International Volunteering"
   },
   {
    "p": "/disaster-recover-build-a-home-philippines-2015/",
    "t": "Disaster Recover Build a Home Philippines 2015"
   },
   {
    "p": "/disaster-relief-programs/",
    "t": "Disaster Relief Programs"
   },
   {
    "p": "/discover-ivis-new-volunteering-opportunity-in-da-lat-vietnam/",
    "t": "Discover IVI's New Volunteering Opportunity in Da Lat Vietnam"
   },
   {
    "p": "/discover-our-turtle-conservation-project-in-bali/",
    "t": "Discover Our Turtle Conservation Project in Bali"
   },
   {
    "p": "/discover-rural-cambodia/",
    "t": "Discover Rural Cambodia"
   },
   {
    "p": "/diving-programs/",
    "t": "Diving Programs"
   },
   {
    "p": "/does-volunteering-make-you-happier/",
    "t": "Does Volunteering Make you Happier"
   },
   {
    "p": "/donate-now/",
    "t": "Donate Now"
   },
   {
    "p": "/donate-to-a-cause/",
    "t": "Donate to a Cause"
   },
   {
    "p": "/donation-confirmation/",
    "t": "Donation Confirmation"
   },
   {
    "p": "/donation-failed/",
    "t": "Donation Failed"
   },
   {
    "p": "/donation-of-1-years-rent/",
    "t": "Donation of 1 Years Rent"
   },
   {
    "p": "/donations-for-the-vanuatu-healthcare-project/",
    "t": "Donations for the Vanuatu Healthcare Project"
   },
   {
    "p": "/donor-dashboard/",
    "t": "Donor Dashboard"
   },
   {
    "p": "/easy-tips-on-how-to-volunteer-abroad/",
    "t": "Easy Tips on How to Volunteer Abroad"
   },
   {
    "p": "/ebook-thank-you/",
    "t": "Ebook Thank you"
   },
   {
    "p": "/elena-rowland-project-hope-fiji-commune/",
    "t": "Elena Rowland Project Hope Fiji Commune"
   },
   {
    "p": "/elephant-adventure-thailand-2015/",
    "t": "Elephant Adventure Thailand 2015"
   },
   {
    "p": "/embracing-culture-shock-when-volunteering-abroad/",
    "t": "Embracing Culture Shock When Volunteering Abroad"
   },
   {
    "p": "/empowering-communities-ivis-new-volunteering-program-in-timor-leste/",
    "t": "Empowering Communities IVI's New Volunteering Program in Timor Leste"
   },
   {
    "p": "/english-exchange-japan-i-taught-the-locals-in-otaki-village-and-kiso-english/",
    "t": "English Exchange Japan I Taught the Locals in Otaki Village and Kiso English"
   },
   {
    "p": "/english-teaching-thailand/",
    "t": "English Teaching Thailand"
   },
   {
    "p": "/enter-the-global-impact-challenge-by-july-31st/",
    "t": "Enter the Global Impact Challenge by July 31st"
   },
   {
    "p": "/environmental-conservation-farming-programs/",
    "t": "Environmental Conservation Farming Programs"
   },
   {
    "p": "/environmental-volunteering-protecting-our-planet/",
    "t": "Environmental Volunteering Protecting Our Planet"
   },
   {
    "p": "/everyday-challenges-volunteers-face-abroad-and-how-to-overcome-them/",
    "t": "Everyday Challenges Volunteers Face Abroad and How to Overcome Them"
   },
   {
    "p": "/exciting-ivi-volunteering-programs-in-2026/",
    "t": "Exciting IVI Volunteering Programs in 2026"
   },
   {
    "p": "/exciting-volunteering-projects-to-join-in-2023/",
    "t": "Exciting Volunteering Projects to Join in 2023"
   },
   {
    "p": "/exploring-otaki-japan-top-things-to-do-in-and-around-nagano-prefecture/",
    "t": "Exploring Otaki Japan Top Things to Do in and Around Nagano Prefecture"
   },
   {
    "p": "/family-volunteering-programs-abroad/",
    "t": "Family Volunteering Programs Abroad"
   },
   {
    "p": "/family-volunteering-in-costa-rica/",
    "t": "Family Volunteering in Costa Rica"
   },
   {
    "p": "/fiji-construction-project/",
    "t": "Fiji Construction Project"
   },
   {
    "p": "/fiji-has-highest-death-rate-from-diabetes-in-the-world/",
    "t": "Fiji Has Highest Death Rate from Diabetes in the World"
   },
   {
    "p": "/fiji-orphanage-placement-2014/",
    "t": "Fiji Orphanage Placement 2014"
   },
   {
    "p": "/fiji-orphanage-program-2015/",
    "t": "Fiji Orphanage Program 2015"
   },
   {
    "p": "/find-best-project-thank-you/",
    "t": "Find Best Project Thank you"
   },
   {
    "p": "/find-out-more-about-cape-verde/",
    "t": "Find Out More About Cape Verde"
   },
   {
    "p": "/find-your-best-project-match/",
    "t": "Find your Best Project Match"
   },
   {
    "p": "/finding-the-right-volunteer-abroad-opportunity-for-you/",
    "t": "Finding the Right Volunteer Abroad Opportunity for you"
   },
   {
    "p": "/first-time-volunteering-abroad-heres-some-tips-and-advice/",
    "t": "First Time Volunteering Abroad Heres Some Tips and Advice"
   },
   {
    "p": "/food-security-covid-19-india%e2%80%8b/",
    "t": "Food Security Covid 19 India%e2%80%8b"
   },
   {
    "p": "/food-security-at-women-childrens-commune-fiji/",
    "t": "Food Security at Women Childrens Commune Fiji"
   },
   {
    "p": "/forestry-conservation-thailand/",
    "t": "Forestry Conservation Thailand"
   },
   {
    "p": "/gap-year-volunteer-programs-abroad/",
    "t": "Gap Year Volunteer Programs Abroad"
   },
   {
    "p": "/gatanga-village-kenya-transforming-through-the-generosity-of-volunteers/",
    "t": "Gatanga Village Kenya Transforming Through the Generosity of Volunteers"
   },
   {
    "p": "/get-to-know-your-hosts-in-cambodia/",
    "t": "Get to Know your Hosts in Cambodia"
   },
   {
    "p": "/group-volunteering/",
    "t": "Group Volunteering"
   },
   {
    "p": "/guide-to-crowdfunding/",
    "t": "Guide to Crowdfunding"
   },
   {
    "p": "/health-education-program-bali/",
    "t": "Health Education Program Bali"
   },
   {
    "p": "/health-and-safety/",
    "t": "Health and Safety"
   },
   {
    "p": "/healthcare-outreach-samoa-report/",
    "t": "Healthcare Outreach Samoa Report"
   },
   {
    "p": "/healthclinic-fiji/",
    "t": "Healthclinic Fiji"
   },
   {
    "p": "/holiday-volunteering-a-different-kind-of-christmas/",
    "t": "Holiday Volunteering a Different Kind of Christmas"
   },
   {
    "p": "/how-volunteering-can-benefit-you/",
    "t": "How Volunteering Can Benefit you"
   },
   {
    "p": "/how-to-choose-the-right-volunteer-program-for-you/",
    "t": "How to Choose the Right Volunteer Program for you"
   },
   {
    "p": "/how-to-create-a-lesson-plan-for-teaching-overseas/",
    "t": "How to Create a Lesson Plan for Teaching Overseas"
   },
   {
    "p": "/how-to-get-the-best-out-of-volunteering-overseas/",
    "t": "How to Get the Best Out of Volunteering Overseas"
   },
   {
    "p": "/how-to-spend-a-weekend-in-nusa-penida-indonesia/",
    "t": "How to Spend a Weekend in Nusa Penida Indonesia"
   },
   {
    "p": "/humanitarian-aid-programs/",
    "t": "Humanitarian Aid Programs"
   },
   {
    "p": "/hydroponic-gardening-projects/",
    "t": "Hydroponic Gardening Projects"
   },
   {
    "p": "/ivi-doing-health-checks-in-5-fiji-resorts/",
    "t": "IVI Doing Health Checks in 5 Fiji Resorts"
   },
   {
    "p": "/ivi-making-progress-in-fiji-vanuatu/",
    "t": "IVI Making Progress in Fiji Vanuatu"
   },
   {
    "p": "/ivi-terms-conditions/",
    "t": "IVI Terms Conditions"
   },
   {
    "p": "/insurance/",
    "t": "Insurance"
   },
   {
    "p": "/intern-with-a-purpose-involvement-volunteers-international/",
    "t": "Intern with a Purpose Involvement Volunteers International"
   },
   {
    "p": "/internships/",
    "t": "Internships"
   },
   {
    "p": "/is-volunteering-abroad-safe-a-full-comparison-risk-guide/",
    "t": "Is Volunteering Abroad Safe a Full Comparison Risk Guide"
   },
   {
    "p": "/is-volunteering-abroad-worth-it-a-realistic-comparison-guide/",
    "t": "Is Volunteering Abroad Worth It a Realistic Comparison Guide"
   },
   {
    "p": "/join-ivi-in-thailand-chiang-mai-and-hua-hin/",
    "t": "Join IVI in Thailand Chiang Mai and Hua Hin"
   },
   {
    "p": "/join-us-in-goa-learn-about-ivis-elderly-special-needs-program/",
    "t": "Join Us in Goa Learn About IVI's Elderly Special Needs Program"
   },
   {
    "p": "/kindergarten-project-suva-2016/",
    "t": "Kindergarten Project Suva 2016"
   },
   {
    "p": "/kindergarten-rebuilding-woman-childrens-commune-fiji/",
    "t": "Kindergarten Rebuilding Woman Childrens Commune Fiji"
   },
   {
    "p": "/kindergarten-teaching-in-suva-fiji/",
    "t": "Kindergarten Teaching in Suva Fiji"
   },
   {
    "p": "/kindergarten-volunteering-in-vietnam/",
    "t": "Kindergarten Volunteering in Vietnam"
   },
   {
    "p": "/lauren-lacey-refugee-crisis/",
    "t": "Lauren Lacey Refugee Crisis"
   },
   {
    "p": "/lesson-plans-for-diverse-classrooms-a-guide-for-volunteer-teachers-abroad/",
    "t": "Lesson Plans for Diverse Classrooms a Guide for Volunteer Teachers Abroad"
   },
   {
    "p": "/long-term-cambodia-teaching/",
    "t": "Long Term Cambodia Teaching"
   },
   {
    "p": "/madagascar-programs-volunteer-on-an-island/",
    "t": "Madagascar Programs Volunteer on an Island"
   },
   {
    "p": "/mardi-himal-trek-in-nepal-a-hidden-gem/",
    "t": "Mardi Himal Trek in Nepal a Hidden Gem"
   },
   {
    "p": "/medical-hospital-internship-options/",
    "t": "Medical Hospital Internship Options"
   },
   {
    "p": "/medical-hospital-public-health-nursing/",
    "t": "Medical Hospital Public Health Nursing"
   },
   {
    "p": "/medical-internship/",
    "t": "Medical Internship"
   },
   {
    "p": "/medical-volunteer-abroad-projects/",
    "t": "Medical Volunteer Abroad Projects"
   },
   {
    "p": "/meet-your-hosts-in-kenya/",
    "t": "Meet your Hosts in Kenya"
   },
   {
    "p": "/meet-your-hosts-in-palawan-philippines/",
    "t": "Meet your Hosts in Palawan Philippines"
   },
   {
    "p": "/meet-your-hosts-in-vietnam/",
    "t": "Meet your Hosts in Vietnam"
   },
   {
    "p": "/mental-health-nutrition-programs-in-fiji-and-vanuatu/",
    "t": "Mental Health Nutrition Programs in Fiji and Vanuatu"
   },
   {
    "p": "/more-volunteer-projects-added-to-ivi/",
    "t": "More Volunteer Projects Added to IVI"
   },
   {
    "p": "/most-affordable-1-week-volunteer-programs-with-ivi/",
    "t": "Most Affordable 1 Week Volunteer Programs with IVI"
   },
   {
    "p": "/most-affordable-ivi-programs-for-long-term-volunteering/",
    "t": "Most Affordable IVI Programs for Long Term Volunteering"
   },
   {
    "p": "/most-ethical-volunteer-abroad-programs-a-full-comparison/",
    "t": "Most Ethical Volunteer Abroad Programs a Full Comparison"
   },
   {
    "p": "/mum-daughter-volunteering-orphanage-fiji-2016/",
    "t": "Mum Daughter Volunteering Orphanage Fiji 2016"
   },
   {
    "p": "/my-account/",
    "t": "My Account"
   },
   {
    "p": "/need-gap-year-age/",
    "t": "Need Gap Year Age"
   },
   {
    "p": "/nepal-construction-project/",
    "t": "Nepal Construction Project"
   },
   {
    "p": "/nepal-medical-internship-team-2017/",
    "t": "Nepal Medical Internship Team 2017"
   },
   {
    "p": "/nepal-volunteering-host-profile/",
    "t": "Nepal Volunteering Host Profile"
   },
   {
    "p": "/new-destination-volunteer-abroad-in-china-with-ivi/",
    "t": "New Destination Volunteer Abroad in China with IVI"
   },
   {
    "p": "/new-flooring-for-philippines-nutrition-center-heena-davidson/",
    "t": "New Flooring for Philippines Nutrition Center Heena Davidson"
   },
   {
    "p": "/new-volunteer-projects-in-madagascar/",
    "t": "New Volunteer Projects in Madagascar"
   },
   {
    "p": "/newsletter/",
    "t": "Newsletter"
   },
   {
    "p": "/nutrition-dietetics-public-health-fiji/",
    "t": "Nutrition Dietetics Public Health Fiji"
   },
   {
    "p": "/nutrition-dietetics-public-health-program/",
    "t": "Nutrition Dietetics Public Health Program"
   },
   {
    "p": "/nutrition-dietetics-public-health-program-fiji-2014/",
    "t": "Nutrition Dietetics Public Health Program Fiji 2014"
   },
   {
    "p": "/nutrition-dietetics-public-health-program-fiji-2016/",
    "t": "Nutrition Dietetics Public Health Program Fiji 2016"
   },
   {
    "p": "/nutrition-health-teaching-bali/",
    "t": "Nutrition Health Teaching Bali"
   },
   {
    "p": "/nutrition-india-study-sarah-wainewright/",
    "t": "Nutrition India Study Sarah Wainewright"
   },
   {
    "p": "/nutrition-program-fiji-2018/",
    "t": "Nutrition Program Fiji 2018"
   },
   {
    "p": "/nutrition-public-health-2019-fiji/",
    "t": "Nutrition Public Health 2019 Fiji"
   },
   {
    "p": "/nutrition-public-health-fiji/",
    "t": "Nutrition Public Health Fiji"
   },
   {
    "p": "/nutrition-public-health-group-outreach-vanuatu/",
    "t": "Nutrition Public Health Group Outreach Vanuatu"
   },
   {
    "p": "/nutrition-public-health-vanuatu/",
    "t": "Nutrition Public Health Vanuatu"
   },
   {
    "p": "/nutrition-and-healthcare-india-project/",
    "t": "Nutrition and Healthcare India Project"
   },
   {
    "p": "/orphanage-program-fiji-2015/",
    "t": "Orphanage Program Fiji 2015"
   },
   {
    "p": "/orphanage-program-fiji-2015-2/",
    "t": "Orphanage Program Fiji 2015 2"
   },
   {
    "p": "/orphanage-program-fiji-2015-3/",
    "t": "Orphanage Program Fiji 2015 3"
   },
   {
    "p": "/orphanage-program-fiji-2015-4/",
    "t": "Orphanage Program Fiji 2015 4"
   },
   {
    "p": "/orphanage-program-fiji-2015-5/",
    "t": "Orphanage Program Fiji 2015 5"
   },
   {
    "p": "/orphanage-volunteering-fiji-2017/",
    "t": "Orphanage Volunteering Fiji 2017"
   },
   {
    "p": "/orphanage-in-fiji/",
    "t": "Orphanage in Fiji"
   },
   {
    "p": "/our-most-affordable-volunteer-abroad-programs-for-2-weeks/",
    "t": "Our Most Affordable Volunteer Abroad Programs for 2 Weeks"
   },
   {
    "p": "/overcoming-challenges-as-a-volunteer-abroad/",
    "t": "Overcoming Challenges as a Volunteer Abroad"
   },
   {
    "p": "/physiotherapy-outreach/",
    "t": "Physiotherapy Outreach"
   },
   {
    "p": "/physiotherapy-public-health-nutrition-fiji-2016/",
    "t": "Physiotherapy Public Health Nutrition Fiji 2016"
   },
   {
    "p": "/power-of-volunteering/",
    "t": "Power of Volunteering"
   },
   {
    "p": "/primary-school-english-teaching/",
    "t": "Primary School English Teaching"
   },
   {
    "p": "/primary-school-english-teaching-thailand/",
    "t": "Primary School English Teaching Thailand"
   },
   {
    "p": "/primary-school-english-teaching-in-bali/",
    "t": "Primary School English Teaching in Bali"
   },
   {
    "p": "/primary-school-teaching/",
    "t": "Primary School Teaching"
   },
   {
    "p": "/primary-school-teaching-samroang-cambodia/",
    "t": "Primary School Teaching Samroang Cambodia"
   },
   {
    "p": "/primary-school-thailand/",
    "t": "Primary School Thailand"
   },
   {
    "p": "/privacy-policy/",
    "t": "Privacy Policy"
   },
   {
    "p": "/programs-by-country/",
    "t": "Programs by Country"
   },
   {
    "p": "/project-fees/",
    "t": "Project Fees"
   },
   {
    "p": "/public-health-nutrition-programs/",
    "t": "Public Health Nutrition Programs"
   },
   {
    "p": "/public-health-outreach-fiji-blog-gabriella/",
    "t": "Public Health Outreach Fiji Blog Gabriella"
   },
   {
    "p": "/public-health-volunteer-work-in-fiji-and-vanuatu-with-ivi/",
    "t": "Public Health Volunteer Work in Fiji and Vanuatu with IVI"
   },
   {
    "p": "/quick-tips-for-packing-for-your-volunteer-trip/",
    "t": "Quick Tips for Packing for your Volunteer Trip"
   },
   {
    "p": "/reasons-why-you-should-volunteer-in-africa-in-2023-2024/",
    "t": "Reasons Why you Should Volunteer in Africa in 2023 2024"
   },
   {
    "p": "/reasons-to-visit-and-volunteer-in-pokhara-nepal/",
    "t": "Reasons to Visit and Volunteer in Pokhara Nepal"
   },
   {
    "p": "/refugee-camps/",
    "t": "Refugee Camps"
   },
   {
    "p": "/refugee-camps-greece-jules-galloway-blog/",
    "t": "Refugee Camps Greece Jules Galloway Blog"
   },
   {
    "p": "/refugee-camps-greece-medical-volunteer-team-2017/",
    "t": "Refugee Camps Greece Medical Volunteer Team 2017"
   },
   {
    "p": "/remote-fiji-construction-project/",
    "t": "Remote Fiji Construction Project"
   },
   {
    "p": "/remote-island-construction-program-fiji-2017/",
    "t": "Remote Island Construction Program Fiji 2017"
   },
   {
    "p": "/remote-island-teaching-program-fiji-2015/",
    "t": "Remote Island Teaching Program Fiji 2015"
   },
   {
    "p": "/remote-island-teaching-program-fiji-2016/",
    "t": "Remote Island Teaching Program Fiji 2016"
   },
   {
    "p": "/remote-island-teaching-program-fiji-2016-2/",
    "t": "Remote Island Teaching Program Fiji 2016 2"
   },
   {
    "p": "/remote-island-teaching-program-fiji-2016-3/",
    "t": "Remote Island Teaching Program Fiji 2016 3"
   },
   {
    "p": "/renovation-construction-programs-abroad/",
    "t": "Renovation Construction Programs Abroad"
   },
   {
    "p": "/risk-assessment/",
    "t": "Risk Assessment"
   },
   {
    "p": "/road-trips/",
    "t": "Road Trips"
   },
   {
    "p": "/rural-cambodia-teaching-zac/",
    "t": "Rural Cambodia Teaching Zac"
   },
   {
    "p": "/rural-community-school-india/",
    "t": "Rural Community School India"
   },
   {
    "p": "/rural-community-volunteering-bodhgaya-2014/",
    "t": "Rural Community Volunteering Bodhgaya 2014"
   },
   {
    "p": "/rural-community-volunteering-bodhgaya-2015/",
    "t": "Rural Community Volunteering Bodhgaya 2015"
   },
   {
    "p": "/rural-community-volunteering-bodhgaya-2015-2/",
    "t": "Rural Community Volunteering Bodhgaya 2015 2"
   },
   {
    "p": "/rural-community-volunteering-bodhgaya-2015-3/",
    "t": "Rural Community Volunteering Bodhgaya 2015 3"
   },
   {
    "p": "/rural-community-volunteering-bodhgaya-2015-4/",
    "t": "Rural Community Volunteering Bodhgaya 2015 4"
   },
   {
    "p": "/rural-community-volunteering-bodhgaya-2016/",
    "t": "Rural Community Volunteering Bodhgaya 2016"
   },
   {
    "p": "/rural-community-volunteering-bodhgaya-2016-2/",
    "t": "Rural Community Volunteering Bodhgaya 2016 2"
   },
   {
    "p": "/rural-medical-volunteering-bodhgaya-2015/",
    "t": "Rural Medical Volunteering Bodhgaya 2015"
   },
   {
    "p": "/rural-school-construction-volunteers-2017/",
    "t": "Rural School Construction Volunteers 2017"
   },
   {
    "p": "/rural-school-teaching-construction-cambodia/",
    "t": "Rural School Teaching Construction Cambodia"
   },
   {
    "p": "/rural-school-volunteering-program-cambodia-2014/",
    "t": "Rural School Volunteering Program Cambodia 2014"
   },
   {
    "p": "/sad-good-bye-host-family-fiji-2016/",
    "t": "Sad Good Bye Host Family Fiji 2016"
   },
   {
    "p": "/safest-volunteer-abroad-programs-a-full-comparison/",
    "t": "Safest Volunteer Abroad Programs a Full Comparison"
   },
   {
    "p": "/safety-tips-for-volunteer-travelers-navigating-first-time-travel/",
    "t": "Safety Tips for Volunteer Travelers Navigating First Time Travel"
   },
   {
    "p": "/safety-and-health-precautions-for-international-volunteers/",
    "t": "Safety and Health Precautions for International Volunteers"
   },
   {
    "p": "/school-teaching-suva/",
    "t": "School Teaching Suva"
   },
   {
    "p": "/short-term-vs-long-term-volunteering-which-is-right-for-you/",
    "t": "Short Term vs Long Term Volunteering Which Is Right for you"
   },
   {
    "p": "/solo-travel-volunteering-how-to-make-friends-abroad/",
    "t": "Solo Travel Volunteering How to Make Friends Abroad"
   },
   {
    "p": "/southeast-asia-best-volunteering-destinations-for-2025/",
    "t": "Southeast Asia Best Volunteering Destinations for 2025"
   },
   {
    "p": "/spanish-classes/",
    "t": "Spanish Classes"
   },
   {
    "p": "/special-needs-fiji/",
    "t": "Special Needs Fiji"
   },
   {
    "p": "/special-needs-school-program-fiji-2015/",
    "t": "Special Needs School Program Fiji 2015"
   },
   {
    "p": "/special-needs-school-program-fiji-2015-2/",
    "t": "Special Needs School Program Fiji 2015 2"
   },
   {
    "p": "/sri-lanka-special-needs-school/",
    "t": "Sri Lanka Special Needs School"
   },
   {
    "p": "/sri-lanka-volunteer-hosts/",
    "t": "Sri Lanka Volunteer Hosts"
   },
   {
    "p": "/stray-dog-rehab-program-kathmandu/",
    "t": "Stray Dog Rehab Program Kathmandu"
   },
   {
    "p": "/street-children-orphanage-vietnam-2015/",
    "t": "Street Children Orphanage Vietnam 2015"
   },
   {
    "p": "/subscribe-thank-you/",
    "t": "Subscribe Thank you"
   },
   {
    "p": "/survivor-couple-elena-rowland-lee-carseldine-in-bodhgaya-india/",
    "t": "Survivor Couple Elena Rowland Lee Carseldine in Bodhgaya India"
   },
   {
    "p": "/teaching-abroad-programs/",
    "t": "Teaching Abroad Programs"
   },
   {
    "p": "/teaching-abroad-resources/",
    "t": "Teaching Abroad Resources"
   },
   {
    "p": "/teaching-abroad-tips-for-volunteers/",
    "t": "Teaching Abroad Tips for Volunteers"
   },
   {
    "p": "/teaching-english-thailand/",
    "t": "Teaching English Thailand"
   },
   {
    "p": "/teaching-english-in-fiji/",
    "t": "Teaching English in Fiji"
   },
   {
    "p": "/teaching-and-adventures-in-nepal/",
    "t": "Teaching and Adventures in Nepal"
   },
   {
    "p": "/teaching-in-fiji-as-a-family-of-4/",
    "t": "Teaching in Fiji as a Family of 4"
   },
   {
    "p": "/teaching-in-fiji-on-remote-island/",
    "t": "Teaching in Fiji on Remote Island"
   },
   {
    "p": "/teaching-in-laos-view/",
    "t": "Teaching in Laos View"
   },
   {
    "p": "/team-tafe-kindergarten-rebuilding-fiji/",
    "t": "Team Tafe Kindergarten Rebuilding Fiji"
   },
   {
    "p": "/thailand-singburi-blog/",
    "t": "Thailand Singburi Blog"
   },
   {
    "p": "/thank-you-gj-gardner-homes/",
    "t": "Thank you Gj Gardner Homes"
   },
   {
    "p": "/the-benefits-of-volunteering-abroad-for-school-leavers/",
    "t": "The Benefits of Volunteering Abroad for School Leavers"
   },
   {
    "p": "/the-best-destinations-to-volunteer-abroad-in-2025-and-why/",
    "t": "The Best Destinations to Volunteer Abroad in 2025 and Why"
   },
   {
    "p": "/the-best-things-to-do-in-laos-new-location/",
    "t": "The Best Things to Do in Laos New Location"
   },
   {
    "p": "/the-best-things-to-do-in-zanzibar-on-days-off/",
    "t": "The Best Things to Do in Zanzibar on Days Off"
   },
   {
    "p": "/the-life-of-a-volunteer-on-fijis-nutrition-projects/",
    "t": "The Life of a Volunteer on Fijis Nutrition Projects"
   },
   {
    "p": "/the-power-of-volunteering-as-a-family/",
    "t": "The Power of Volunteering as a Family"
   },
   {
    "p": "/the-realities-of-volunteering-abroad-what-to-expect/",
    "t": "The Realities of Volunteering Abroad What to Expect"
   },
   {
    "p": "/the-refugee-crisis-in-greece/",
    "t": "The Refugee Crisis in Greece"
   },
   {
    "p": "/things-people-dont-tell-you-about-volunteering/",
    "t": "Things People Dont Tell you About Volunteering"
   },
   {
    "p": "/things-to-do-in-cape-verde-a-volunteers-guide-to-tarrafal-and-beyond/",
    "t": "Things to Do in Cape Verde a Volunteers Guide to Tarrafal and Beyond"
   },
   {
    "p": "/things-to-do-in-guangxi-china-for-volunteers/",
    "t": "Things to Do in Guangxi China for Volunteers"
   },
   {
    "p": "/things-to-do-in-lisbon-a-guide-for-volunteers-abroad/",
    "t": "Things to Do in Lisbon a Guide for Volunteers Abroad"
   },
   {
    "p": "/things-to-do-in-lombok-indonesia-a-volunteers-guide/",
    "t": "Things to Do in Lombok Indonesia a Volunteers Guide"
   },
   {
    "p": "/things-to-do-in-morocco-exploring-rabat-and-beyond/",
    "t": "Things to Do in Morocco Exploring Rabat and Beyond"
   },
   {
    "p": "/things-to-do-in-nosy-komba-madagascar-new-projects/",
    "t": "Things to Do in Nosy Komba Madagascar New Projects"
   },
   {
    "p": "/things-to-do-in-nosy-komba-madagascar-a-complete-guide/",
    "t": "Things to Do in Nosy Komba Madagascar a Complete Guide"
   },
   {
    "p": "/things-to-do-in-palawan-philippines/",
    "t": "Things to Do in Palawan Philippines"
   },
   {
    "p": "/things-to-do-in-udaipur-india-weekend-guide-for-volunteers/",
    "t": "Things to Do in Udaipur India Weekend Guide for Volunteers"
   },
   {
    "p": "/things-to-do-in-and-near-samraong-cambodia/",
    "t": "Things to Do in and Near Samraong Cambodia"
   },
   {
    "p": "/tips-for-solo-female-travellers-in-ghana/",
    "t": "Tips for Solo Female Travellers in Ghana"
   },
   {
    "p": "/top-10-countries-for-volunteering-abroad-in-2025/",
    "t": "Top 10 Countries for Volunteering Abroad in 2025"
   },
   {
    "p": "/top-10-eco-environmental-volunteer-abroad-programs/",
    "t": "Top 10 Eco Environmental Volunteer Abroad Programs"
   },
   {
    "p": "/top-11-medical-and-healthcare-programs-abroad-with-ivi-for-2025/",
    "t": "Top 11 Medical and Healthcare Programs Abroad with IVI for 2025"
   },
   {
    "p": "/top-20-volunteer-projects/",
    "t": "Top 20 Volunteer Projects"
   },
   {
    "p": "/top-5-womens-empowerment-programs-abroad/",
    "t": "Top 5 Womens Empowerment Programs Abroad"
   },
   {
    "p": "/top-ivi-projects-for-volunteering-with-children/",
    "t": "Top IVI Projects for Volunteering with Children"
   },
   {
    "p": "/top-medical-volunteering-abroad-programs-for-2022-2023/",
    "t": "Top Medical Volunteering Abroad Programs for 2022 2023"
   },
   {
    "p": "/top-reasons-to-choose-ivi-for-animal-shelter-projects/",
    "t": "Top Reasons to Choose IVI for Animal Shelter Projects"
   },
   {
    "p": "/top-reasons-to-choose-ivi-for-construction-projects/",
    "t": "Top Reasons to Choose IVI for Construction Projects"
   },
   {
    "p": "/top-reasons-to-choose-ivi-for-cultural-orientation-programs/",
    "t": "Top Reasons to Choose IVI for Cultural Orientation Programs"
   },
   {
    "p": "/top-reasons-to-choose-ivi-for-elephant-conservation/",
    "t": "Top Reasons to Choose IVI for Elephant Conservation"
   },
   {
    "p": "/top-reasons-to-choose-ivi-for-english-teaching-overseas/",
    "t": "Top Reasons to Choose IVI for English Teaching Overseas"
   },
   {
    "p": "/top-reasons-to-choose-ivi-for-environmental-projects/",
    "t": "Top Reasons to Choose IVI for Environmental Projects"
   },
   {
    "p": "/top-reasons-to-choose-ivi-for-kindergarten-teaching/",
    "t": "Top Reasons to Choose IVI for Kindergarten Teaching"
   },
   {
    "p": "/top-reasons-to-choose-ivi-for-nutrition-and-public-health-volunteering/",
    "t": "Top Reasons to Choose IVI for Nutrition and Public Health Volunteering"
   },
   {
    "p": "/top-reasons-to-choose-ivi-for-remote-island-teaching/",
    "t": "Top Reasons to Choose IVI for Remote Island Teaching"
   },
   {
    "p": "/top-things-to-do-in-bali-guide-for-travellers-and-volunteers/",
    "t": "Top Things to Do in Bali Guide for Travellers and Volunteers"
   },
   {
    "p": "/top-things-to-do-in-cape-town-south-africa/",
    "t": "Top Things to Do in Cape Town South Africa"
   },
   {
    "p": "/travelee/",
    "t": "Travelee"
   },
   {
    "p": "/travelling-to-vietnam-during-tet-lunar-new-year-2026/",
    "t": "Travelling to Vietnam During Tet Lunar New Year 2026"
   },
   {
    "p": "/trekking-programs-abroad/",
    "t": "Trekking Programs Abroad"
   },
   {
    "p": "/turtle-conservation-adventure-in-bali/",
    "t": "Turtle Conservation Adventure in Bali"
   },
   {
    "p": "/types-of-volunteer-projects-abroad-that-make-a-difference/",
    "t": "Types of Volunteer Projects Abroad That Make a Difference"
   },
   {
    "p": "/ultimate-guide-to-exploring-nadi-fiji-best-things-to-do/",
    "t": "Ultimate Guide to Exploring Nadi Fiji Best Things to Do"
   },
   {
    "p": "/unique-destinations-to-volunteer-abroad/",
    "t": "Unique Destinations to Volunteer Abroad"
   },
   {
    "p": "/unique-volunteer-programs-in-central-and-south-america/",
    "t": "Unique Volunteer Programs in Central and South America"
   },
   {
    "p": "/vanuatu-public-health-outreach-blog-cherry-wong/",
    "t": "Vanuatu Public Health Outreach Blog Cherry Wong"
   },
   {
    "p": "/veterinary-care-volunteering-fiji/",
    "t": "Veterinary Care Volunteering Fiji"
   },
   {
    "p": "/video-competition/",
    "t": "Video Competition"
   },
   {
    "p": "/volunteer-donation-fiji/",
    "t": "Volunteer Donation Fiji"
   },
   {
    "p": "/volunteer-donations-making-a-difference-in-bodhgaya/",
    "t": "Volunteer Donations Making a Difference in Bodhgaya"
   },
   {
    "p": "/volunteer-projects-to-suit-every-type-of-traveller/",
    "t": "Volunteer Projects to Suit Every Type of Traveller"
   },
   {
    "p": "/volunteer-teaching-bali/",
    "t": "Volunteer Teaching Bali"
   },
   {
    "p": "/volunteer-in-central-america-and-south-america-this-year/",
    "t": "Volunteer in Central America and South America This Year"
   },
   {
    "p": "/volunteer-in-malawi-with-ivi-visit-the-warm-heart-of-africa/",
    "t": "Volunteer in Malawi with IVI Visit the Warm Heart of Africa"
   },
   {
    "p": "/volunteer-with-animals/",
    "t": "Volunteer with Animals"
   },
   {
    "p": "/volunteer-with-animals-our-top-7-projects-abroad/",
    "t": "Volunteer with Animals Our Top 7 Projects Abroad"
   },
   {
    "p": "/volunteer-with-cheetahs-in-cape-town-south-africa/",
    "t": "Volunteer with Cheetahs in Cape Town South Africa"
   },
   {
    "p": "/volunteer-with-refugees-make-a-real-impact-around-the-world/",
    "t": "Volunteer with Refugees Make a Real Impact Around the World"
   },
   {
    "p": "/volunteering-abroad-at-any-age-why-you-should-do-it-and-its-impact/",
    "t": "Volunteering Abroad at Any Age Why you Should Do It and Its Impact"
   },
   {
    "p": "/volunteering-abroad-at-christmas-making-the-holiday-season-meaningful/",
    "t": "Volunteering Abroad at Christmas Making the Holiday Season Meaningful"
   },
   {
    "p": "/volunteering-abroad-for-first-timers/",
    "t": "Volunteering Abroad for First Timers"
   },
   {
    "p": "/volunteering-good-career/",
    "t": "Volunteering Good Career"
   },
   {
    "p": "/volunteering-making-a-difference-in-a-time-of-crisis/",
    "t": "Volunteering Making a Difference in a Time of Crisis"
   },
   {
    "p": "/volunteering-nutrition-programs-abroad/",
    "t": "Volunteering Nutrition Programs Abroad"
   },
   {
    "p": "/volunteering-overseas-broke-my-heart/",
    "t": "Volunteering Overseas Broke My Heart"
   },
   {
    "p": "/volunteering-in-asia-is-a-perfection/",
    "t": "Volunteering in Asia Is a Perfection"
   },
   {
    "p": "/volunteering-in-education-teaching-abroad/",
    "t": "Volunteering in Education Teaching Abroad"
   },
   {
    "p": "/volunteering-in-madagascar-adventure-awaits/",
    "t": "Volunteering in Madagascar Adventure Awaits"
   },
   {
    "p": "/volunteering-in-southeast-asia-what-you-need-to-know-before-you-go/",
    "t": "Volunteering in Southeast Asia What you Need to Know Before you Go"
   },
   {
    "p": "/volunteering-with-children/",
    "t": "Volunteering with Children"
   },
   {
    "p": "/volunteers-guide-to-uganda-what-to-do-near-kajjansi-more/",
    "t": "Volunteers Guide to Uganda What to Do Near Kajjansi More"
   },
   {
    "p": "/we-are-looking-for-nutrition-and-public-health-vollies/",
    "t": "We Are Looking for Nutrition and Public Health Vollies"
   },
   {
    "p": "/we-attended-torrens-uni-open-day-for-students-interested-in-health-courses/",
    "t": "We Attended Torrens Uni Open Day for Students Interested in Health Courses"
   },
   {
    "p": "/what-its-like-to-volunteer-in-colombia/",
    "t": "What Its Like to Volunteer in Colombia"
   },
   {
    "p": "/what-makes-a-great-volunteer-abroad/",
    "t": "What Makes a Great Volunteer Abroad"
   },
   {
    "p": "/what-to-expect-when-volunteering-in-fiji/",
    "t": "What to Expect When Volunteering in Fiji"
   },
   {
    "p": "/what-to-expect-as-a-volunteer-borneo-malaysia/",
    "t": "What to Expect as a Volunteer Borneo Malaysia"
   },
   {
    "p": "/what-to-expect-as-a-volunteer-in-bali/",
    "t": "What to Expect as a Volunteer in Bali"
   },
   {
    "p": "/whats-involved-on-our-nutrition-projects-in-fiji/",
    "t": "Whats Involved on Our Nutrition Projects in Fiji"
   },
   {
    "p": "/whats-the-best-organization-for-community-focused-volunteering-in-fiji/",
    "t": "Whats the Best Organization for Community Focused Volunteering in Fiji"
   },
   {
    "p": "/whats-the-best-organization-for-community-volunteering-in-thailand/",
    "t": "Whats the Best Organization for Community Volunteering in Thailand"
   },
   {
    "p": "/whats-the-best-volunteering-organization-for-families-volunteering-in-fiji/",
    "t": "Whats the Best Volunteering Organization for Families Volunteering in Fiji"
   },
   {
    "p": "/whats-the-best-volunteering-organization-for-families-volunteering-in-thailand/",
    "t": "Whats the Best Volunteering Organization for Families Volunteering in Thailand"
   },
   {
    "p": "/whats-the-best-volunteering-organization-for-teaching-english-in-thailand/",
    "t": "Whats the Best Volunteering Organization for Teaching English in Thailand"
   },
   {
    "p": "/where-does-your-money-go-when-you-volunteer-abroad-with-ivi/",
    "t": "Where Does your Money Go When you Volunteer Abroad with IVI"
   },
   {
    "p": "/where-should-i-volunteer-in-thailand-koh-samui-chiang-mai-and-hua-hin/",
    "t": "Where Should I Volunteer in Thailand Koh Samui Chiang Mai and Hua Hin"
   },
   {
    "p": "/which-country-in-south-america-to-visit-peru-costa-rica-or-guatemala/",
    "t": "Which Country in South America to Visit Peru Costa Rica or Guatemala"
   },
   {
    "p": "/whos-best-for-cultural-volunteering-programs-in-bali/",
    "t": "Whos Best for Cultural Volunteering Programs in Bali"
   },
   {
    "p": "/whos-best-for-cultural-volunteering-programs-in-thailand/",
    "t": "Whos Best for Cultural Volunteering Programs in Thailand"
   },
   {
    "p": "/whos-the-best-volunteer-abroad-organization-a-full-comparison/",
    "t": "Whos the Best Volunteer Abroad Organization a Full Comparison"
   },
   {
    "p": "/whos-the-best-volunteering-organization-for-first-time-volunteers-in-bali/",
    "t": "Whos the Best Volunteering Organization for First Time Volunteers in Bali"
   },
   {
    "p": "/whos-the-best-volunteering-organization-for-first-time-volunteers-in-fiji/",
    "t": "Whos the Best Volunteering Organization for First Time Volunteers in Fiji"
   },
   {
    "p": "/whos-the-best-volunteering-organization-for-first-time-volunteers-in-thailand/",
    "t": "Whos the Best Volunteering Organization for First Time Volunteers in Thailand"
   },
   {
    "p": "/whos-the-best-volunteering-organization-for-students-in-fiji/",
    "t": "Whos the Best Volunteering Organization for Students in Fiji"
   },
   {
    "p": "/whos-the-best-volunteering-organization-for-students-in-thailand/",
    "t": "Whos the Best Volunteering Organization for Students in Thailand"
   },
   {
    "p": "/why-2026-is-the-year-to-volunteer-with-ivi/",
    "t": "Why 2026 Is the Year to Volunteer with IVI"
   },
   {
    "p": "/why-should-you-volunteer-abroad-in-2025-travel-with-a-non-profit/",
    "t": "Why Should you Volunteer Abroad in 2025 Travel with a Non Profit"
   },
   {
    "p": "/why-should-you-volunteer-abroad-with-ivi/",
    "t": "Why Should you Volunteer Abroad with IVI"
   },
   {
    "p": "/why-volunteer-abroad-as-a-family/",
    "t": "Why Volunteer Abroad as a Family"
   },
   {
    "p": "/why-volunteer-abroad-with-ivi/",
    "t": "Why Volunteer Abroad with IVI"
   },
   {
    "p": "/why-volunteer-in-ecuador-with-ivi/",
    "t": "Why Volunteer in Ecuador with IVI"
   },
   {
    "p": "/why-volunteer-on-a-medical-program-abroad-with-ivi/",
    "t": "Why Volunteer on a Medical Program Abroad with IVI"
   },
   {
    "p": "/why-volunteer-with-ivi-in-2024/",
    "t": "Why Volunteer with IVI in 2024"
   },
   {
    "p": "/why-volunteering-abroad-can-change-your-life/",
    "t": "Why Volunteering Abroad Can Change your Life"
   },
   {
    "p": "/why-volunteering-abroad-is-more-than-just-travel/",
    "t": "Why Volunteering Abroad Is More Than Just Travel"
   },
   {
    "p": "/why-you-should-volunteer-in-south-asia/",
    "t": "Why you Should Volunteer in South Asia"
   },
   {
    "p": "/woman-and-childrens-commune-fiji/",
    "t": "Woman and Childrens Commune Fiji"
   },
   {
    "p": "/women-empowerment-programs/",
    "t": "Women Empowerment Programs"
   }
  ]
 }
];

export const SITEMAP_TOTAL = SITEMAP_GROUPS.reduce((n, g) => n + g.items.length, 0);
